import React, {
  useEffect,
  useState,
  ChangeEvent,
  useCallback,
  useRef, useMemo
} from "react";
import "./User.scss";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  Row,
} from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Billing from "./Billing/Billing";
import Shipping from "./Shipping/Shipping";
import Places from "./Places/Places";
import Cart from "../Cart/Cart";
import { CartData } from "../../interfaces/CartData";
import Payment from "./Payment/Payment";
import { useCart } from "../../services/cartService";
import { useAuth } from "../../services/authService";
import { ShippingOption } from "../../interfaces/ShippingOption";
import { useHeaderMenu } from "../../contexts/login.context";
import nvCookieHelpers from "../../services/cookieService";
import useLoader from "../../contexts/LoaderContext";
import cartLoader from "../../assets/images/cart_Loader.gif";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa6";
import { config } from "../../config";
import { formatPhoneNo } from "../../helpers/common";
import { initialize } from "@nv-ces/ucp-wrapper";
import { v4 as uuidv4 } from "uuid";
import * as validate from "./helper";
import { PaymentEvents } from "./constants";
import * as intrfce from "./Interfaces";
import { useLocalization } from "../../contexts/LocalizationContext";
import BillingJapan from "./Billing/BillingJapan";
import PlacesJapan from "./Places/PlacesJapan";
import AddressModal from "./AddressModal/AddressModal";

const User = () => {
  const { userType } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const RESET_ADDRESS = "reset";
  // Extracting sourceId from the URL
  const queryParams = new URLSearchParams(useLocation().search);
  const orderState = queryParams.get("order");
  const sourceId = orderState ? undefined : queryParams.get("sourceId");
  const partnerFlag: any = orderState ? undefined : queryParams.get("partner");
  const isDownload: boolean = false;
  const isVerify: boolean = false;
  const isThanks: boolean = false;
  const [isShipping, setIsShipping] = useState(false);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState<
    intrfce.iSavedAddress | null | typeof RESET_ADDRESS
  >(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState<
    intrfce.iSavedAddress | null | typeof RESET_ADDRESS
  >(null);
  const [savedBillingAddress, setSavedBillingAddress] = useState<
    intrfce.iSavedAddress[]
  >([]);
  const [savedShippingAddress, setSavedShippingAddress] = useState<
    intrfce.iSavedAddress[]
  >([]);
  const [isShippingReadonly, setIsShippingReadonly] = useState(false);
  const [isBillingReadonly, setIsBillingReadonly] = useState(false);
  const [couponCode, setCoupon] = useState<string | null>(null);
  const futureUse = true;
  const [cartData, setCartData] = useState<CartData | undefined>();
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string>
  >({});
  const [payment, setPayment] = useState(sourceId ? "payPal" : "creditCard");
  const [enableReviewOrderBtn, setEnableReviewOrderBtn] =
    useState<boolean>(false);
  const {
    showBodyLoader,
    hideBodyLoader,
    isCartLoading,
    hideCartLoader,
    showCartLoader,
  } = useLoader();
  const [isPhysicalGiftCard, setPhysicalGiftCard] = useState<boolean>(false);
  const [promoErr, setPromoErr] = useState<boolean>(false);
  const [addressErr, setAddressErr] = useState<null | string>(null);
  const [savePayment, setSavePayment] = useState(false);
  const { locale, localeWith_, stateDropdown, countryList, countryListPhysical, currencySign, countyField } = useLocalization();
  const {
    setItemsInCart,
    isPartner,
    setIsPartner,
    order,
    setOrder,
    isDirect,
    setIsDirect,
    isDownload: isDigitalProduct,
    setIsDownload,
    brand,
    setBrand
  } = useHeaderMenu();
  const [paymentEventMessage, setPaymentEventMessage] = useState<string | null>(
    null
  );
  const [validPayment, setValidPayment] = useState<boolean>(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [addressValidationResult, setAddressValidationResult] =
    useState<any>(null);
  const [selectedAddressOption, setSelectedAddressOption] =
    useState("yourAddress");
  const [temporaryAddress, setTemporaryAddress] =
    useState<intrfce.iSavedAddress | null>(null);
  const [recommendedShippingAddress, setRecommendedShippingAddress] =
    useState<intrfce.iAddressFormData | null>(null);

  const countries = useMemo(() => {
    return (isDigitalProduct ? countryList : (countryListPhysical || countryList));
  }, [isDigitalProduct, countryList, countryListPhysical])

  if (userType) {
    sessionStorage.setItem("customer", userType);
  } else {
    // Handle the case when userType is undefined
    navigate(`/${locale}/software/cart/`);
  }

  const handleLogin = () => {
    window.location.href = `${config.bcSSOLoginUrl}${locale}/software/cart`;

  };

  const reviewOrder = (user: string) => {
    navigate(`/${locale}/software/cart/verify`, { state: { user, validationErrors } });
  };

  const emptyCart = (msg: string, pid?: number) => {
    navigate(`/${locale}/software/cart/empty`, { state: { msg, pid } });
  };

  const [formBillingAddress, setFormBillingAddress] =
    useState<intrfce.iAddressFormData>({
      pincode: "",
      address: "",
      line2: '',
      cityValue: "",
      stateValue: locale === 'zh-tw' ? "TW" : "",
      countryName: countries[0].countryName,
      countryValue: countries[0].ISO_CC,
    });

  const [formShippingAddress, setFormShippingAddress] =
    useState<intrfce.iAddressFormData>({
      pincode: "",
      address: "",
      line2: '',
      cityValue: "",
      stateValue: locale === 'zh-tw' ? "TW" : "",
      countryName: countries[0].countryName,
      countryValue: countries[0].ISO_CC,
    });

  const [shippingOptions, setShippingOptions] =
    useState<intrfce.iShippingDetails>({
      shippingOption: 0,
      shippingTo: "residence",
    });
  const [shippingPlace, setShippingPlace] = useState<
    intrfce.ishippingPlaceObj[]
  >([]);
  const [shippingList, setShippingList] = useState<ShippingOption[]>([]);
  const [formBillingData, setFormBillingData] =
    useState<intrfce.iBillingFormData>({
      firstNameBilling: "",
      lastNameBilling: "",
      contactBilling: "",
      emailBilling: "",
      vemailBilling: "",
      passwordBilling: "",
      vpasswordBilling: "",
    });
  const [formTaxData, setFormTaxData] = useState<intrfce.iTaxFormData>({
    companyName: "",
    taxAuthority: "",
    startDate: "",
    startYear: "",
    expireDate: "",
    expireYear: "",
    taxFile: null,
  });
  const [formData, setFormData] = useState<intrfce.iFormContainer>({
    firstNameShiping: "",
    lastNameShiping: "",
    contactShiping: "",
    iBillingFormData: formBillingData,
    iBillingFormAddress: formBillingAddress,
    iShippingDetails: shippingOptions,
    iShippingFormAddress: formShippingAddress,
  });

  const validateForm = useCallback(
    (
      fieldName: string,
      value: string | {} | boolean,
      formType: "billing" | "shipping" | ""
    ): boolean => {
      let error = "";
      switch (fieldName) {
        case "firstNameBilling":
          if (
            !formBillingData.firstNameBilling ||
            formBillingData.firstNameBilling.trim() === ""
          ) {
            error = t("FIRST_NAME_EMPTY");
          } else if (
            !validate.validateInput(formBillingData.firstNameBilling)
          ) {
            error = t("FIRST_NAME_INVALID");
          }
          break;
        case "lastNameBilling":
          if (
            !formBillingData.lastNameBilling ||
            formBillingData.lastNameBilling.trim() === ""
          ) {
            error = t("LAST_NAME_EMPTY");
          } else if (!validate.validateInput(formBillingData.lastNameBilling)) {
            error = t("LAST_NAME_INVALID");
          }
          break;
        case "emailBilling":
          if (userType === "loggedIn") {
            if (
              !formBillingData.emailBilling ||
              formBillingData.emailBilling.trim() === ""
            ) {
              error = t("EMAIL_ADDRESS_EMPTY");
            } else if (!validate.validateEmail(formBillingData.emailBilling)) {
              error = t("EMAIL_ADDRESS_INVALID");
            }
          }
          break;
        case "vemailBilling":
          if (userType !== "loggedIn") {
            if (
              !formBillingData.vemailBilling ||
              formBillingData.vemailBilling.trim() === ""
            ) {
              error = t("EMAIL_ADDRESS_EMPTY");
            } else if (!validate.validateEmail(formBillingData.vemailBilling)) {
              error = t("EMAIL_ADDRESS_INVALID");
            } else if (
              formBillingData.vemailBilling !== formBillingData.emailBilling
            ) {
              error = t("EMAIL_ADDRESS_MISMATCH");
            }
          }
          break;
        case "contactBilling":
          if (
            !formBillingData.contactBilling ||
            formBillingData.contactBilling.trim() === ""
          ) {
            error = t("CONTACT_NUMBER_EMPTY");
          } else if (
            !validate.validateContactNumber(formBillingData.contactBilling)
          ) {
            error = t("CONTACT_NUMBER_INVALID");
          }
          break;
        case "passwordBilling":
          if (
            userType !== "loggedIn" &&
            userType === "register" &&
            formBillingData.passwordBilling.trim() === ""
          ) {
            error = t("PASSWORD_EMPTY");
          } else if (
            userType === "register" &&
            !validate.validatePassword(formBillingData.passwordBilling)
          ) {
            error = t("PASSWORD_INVALID");
          }
          break;
        case "vpasswordBilling":
          if (userType !== "loggedIn" && userType === "register") {
            if (formBillingData.vpasswordBilling.trim() === "") {
              error = t("PASSWORD_EMPTY");
            } else if (
              formBillingData.passwordBilling !==
              formBillingData.vpasswordBilling
            ) {
              error = t("PASSWORD_MISMATCH");
            }
          }
          break;
        case "firstNameShiping":
          if (!value || (value as string).trim() === "") {
            error = t("FIRST_NAME_EMPTY");
          } else if (!validate.validateInput(value as string)) {
            error = t("FIRST_NAME_INVALID");
          }
          break;
        case "lastNameShiping":
          if (!value || (value as string).trim() === "") {
            error = t("LAST_NAME_EMPTY");
          } else if (!validate.validateInput(value as string)) {
            error = t("LAST_NAME_INVALID");
          }
          break;

        case "contactShiping":
          if (!value || (value as string).trim() === "") {
            error = t("CONTACT_NUMBER_EMPTY");
          } else if (!validate.validateContactNumber(value as string)) {
            error = t("CONTACT_NUMBER_INVALID");
          }
          break;
        case "shippingOption":
          if (!shippingOptions.shippingOption) {
            error = t("SHIPPING_OPTION_REQUIRED");
          }
          break;
        case "shippingTo":
          if (!shippingOptions.shippingTo) {
            error = t("SHIPPING_ATTRIBUTE_REQUIRED");
          }
          break;
        case "pincode":
          if (locale !== 'en-hk' && (formBillingAddress['countryValue'] !== 'PA' && locale !== 'es-la')) {
            if (!value || (value as string).trim() === "") {
              error = t("ZIP_CODE_EMPTY");
            } else if (!validate.validatePostalCodes(value as string, locale, formType === "billing" ? formBillingAddress.countryValue : formShippingAddress.countryValue)) {
              error = t("ZIP_CODE_INVALID");
            }
          }
          break;
        case "address":
          if (!value || (value as string).trim() === "") {
            error = t("ADDRESS_REQUIRED");
          } else if (
            !validate.validateStringOrIntegerAddress(value as string, locale)
          ) {
            error = t("ADDRESS_INVALID");
          } else {
            if (!validate.validateAddress(value as string)) {
              error = t("ADDRESS_PO_BOX");
            }
          }
          break;
        case "cityValue":
          if (!value || (value as string).trim() === "") {
            error = t("CITY_REQUIRED");
          } else if (
            !value ||
            !validate.validateCity(value as string, locale)
          ) {
            error = t("CITY_INVALID");
          }
          break;
        case "stateValue":
          if (stateDropdown && locale !== 'en-me' && (formBillingAddress['countryValue'] !== 'PA' && locale !== 'es-la') ) {
            if (!value || (value as string).trim() === "") {
              error = t("STATE_EMPTY");
            } else if (!validate.validateInput(value as string)) {
              error = t("STATE_INVALID");
            }
          }
          break;
        case "companyName":
          if ((value as string).trim() === "") {
            error = "Company Name is required";
          } else if (!validate.validateInput(value as string)) {
            error = "Company Name is invalid";
          }
          break;
        case "taxAuthority":
          if ((value as string).trim() === "") {
            error = "Tax Authority is required";
          } else if (!validate.validateInput(value as string)) {
            error = "Tax Authority is invalid";
          }
          break;
        case "startDate":
          if ((value as string).trim() === "") {
            error = "Start Date is required";
          } else if (!validate.validateInput(value as string)) {
            error = "Start Date is invalid";
          }
          break;
        case "startYear":
          if ((value as string).trim() === "") {
            error = "Start Year is required";
          } else if (!validate.validateInput(value as string)) {
            error = "Start Year is invalid";
          }
          break;
        case "expireDate":
          if ((value as string).trim() === "") {
            error = "Expire Date is required";
          } else if (!validate.validateInput(value as string)) {
            error = "Expire Date is invalid";
          }
          break;
        case "expireYear":
          if ((value as string).trim() === "") {
            error = "Expire Year is required";
          } else if (!validate.validateInput(value as string)) {
            error = "Expire Year is invalid";
          }
          break;
        case "taxFile":
          const fileValue = value as File;
          if ((value as string).trim() === "") {
            error = "Tax File is required";
          } else {
            const fileSizeLimit = 10 * 1024 * 1024; // 10 MB in bytes
            const allowedFileTypes = [
              "image/bmp",
              "image/gif",
              "image/jpeg",
              "image/png",
              "application/pdf",
            ];
            if (fileValue.size > fileSizeLimit) {
              error =
                "File size exceeds the limit (10 MB), Please select a smaller file.";
            } else if (!allowedFileTypes.includes(fileValue.type)) {
              error =
                "Extension not allowed, Please select a BMP, GIF, JPG, PNG, or PDF file.";
            }
          }
          break;
        default:
          break;
      }
      // Validation logic for billing fields
      if (formType === "billing") {
        switch (fieldName) {
          case "cityBilling":
            if (!value || (value as string).trim() === "") {
              error = t("CITY_REQUIRED");
            } else if (
              !value ||
              !validate.validateCity(value as string, locale)
            ) {
              error = t("CITY_INVALID");
            }
            break;
          case "stateNameBilling":
            if (!value || (value as string).trim() === "") {
              error = t("STATE_EMPTY");
            } else if (!validate.validateInput(value as string)) {
              error = t("STATE_INVALID");
            }
            break;
          case "zipBilling":
            if (!value || (value as string).trim() === "") {
              error = t("ZIP_CODE_EMPTY");
            } else if (!validate.validatePostalCodes(value as string, locale, formBillingAddress.countryValue)) {
              error = t("ZIP_CODE_INVALID");
            }
            break;
          case "countryBilling":
            if (!value || (value as string).trim() === "") {
              error = t("COUNTRY_REQUIRED");
            } else if (!validate.validateInput(value as string)) {
              error = t("COUNTRY_INVALID");
            }
            break;
          case "addressBilling":
            if (!value || (value as string).trim() === "") {
              error = t("ADDRESS_REQUIRED");
            } else if (
              !validate.validateStringOrIntegerAddress(value as string, locale)
            ) {
              error = t("ADDRESS_INVALID");
            } else {
              if (!validate.validateAddress(value as string)) {
                error = t("ADDRESS_PO_BOX");
              }
            }
            break;
          default:
            break;
        }
      }
      // Validation logic for shipping fields
      if (formType === "shipping") {
        switch (fieldName) {
          case "cityShipping":
            if (!value || (value as string).trim() === "") {
              error = t("CITY_REQUIRED");
            } else if (
              !value ||
              !validate.validateCity(value as string, locale)
            ) {
              error = t("CITY_INVALID");
            }
            break;
          case "stateNameShipping":
            if (!value || (value as string).trim() === "") {
              error = t("STATE_EMPTY");
            } else if (!validate.validateInput(value as string)) {
              error = t("STATE_INVALID");
            }
            break;
          case "zipShipping":
            if (!value || (value as string).trim() === "") {
              error = t("ZIP_CODE_EMPTY");
            } else if (!validate.validatePostalCodes(value as string, locale, formShippingAddress.countryValue)) {
              error = t("ZIP_CODE_INVALID");
            }
            break;
          case "countryShipping":
            if (!value || (value as string).trim() === "") {
              error = t("COUNTRY_REQUIRED");
            } else if (!validate.validateInput(value as string)) {
              error = t("COUNTRY_INVALID");
            }
            break;
          case "addressShipping":
            if (!value || (value as string).trim() === "") {
              error = t("ADDRESS_REQUIRED");
            } else if (
              !validate.validateStringOrIntegerAddress(value as string, locale)
            ) {
              error = t("ADDRESS_INVALID");
            } else {
              if (!validate.validateAddress(value as string)) {
                error = t("ADDRESS_PO_BOX");
              }
            }
            break;
          default:
            break;
        }
      }
      const errors: Record<string, string> = { [fieldName]: error };
      if (
        fieldName === "pincode" ||
        fieldName === "address" ||
        fieldName === "cityValue" ||
        fieldName === "stateValue"
      ) {
        let errorFieldName = formType + fieldName;
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [errorFieldName]: error,
        }));
      }
      if (fieldName !== "promoCode") {
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: error,
        }));
      }
      return errors[fieldName].length === 0;

      // return Object.keys(errors).length === 0;
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formData, formBillingData, formBillingAddress, formShippingAddress, shippingOptions, setValidationErrors, locale, t, userType]
  );
  const orderAccount = () => {
    if (partnerFlag) {
      if (isDirect) {
        window.location.href = config.bcDirectOrdersUrl;
      } else {
        window.location.href = config.bcOrdersUrl;
      }
    }
  };
  const isEmptyString = (value: any) => {
    return (
      value === undefined || (typeof value === "string" && value.trim() === "")
    );
  };

  const isObjectEmpty = (obj: any) => {
    if (obj === null || obj === undefined || typeof obj !== "object") {
      return isEmptyString(obj);
    }
    return Object.values(obj).every(value => value === null || value === "" || value === undefined);
  };
  const isBillingAddressValid = (): boolean => {
    // First check if the address has any fields other than countryName and countryValue
    const hasOtherFields = Object.entries(formBillingAddress).some(
      ([key, value]) => {
        // Skip countryName, countryValue, and stateValue (when not en-us) in the check
        if (
          key === "countryName" ||
          key === "countryValue" ||
          (key === "stateValue" && locale !== "en-us")
        ) {
          return false;
        }
        return !isEmptyString(value);
      }
    );

    if (!hasOtherFields) {
      return false;
    }

    // Now validate all fields if other fields are present
    if (!isObjectEmpty(formBillingAddress)) {
      for (const [fieldName, value] of Object.entries(formBillingAddress)) {
        // Skip validation for stateValue when locale is not en-us
        if (fieldName === "stateValue" && locale !== "en-us") {
          continue;
        }
        const fieldIsValid = validateForm(fieldName, value, "billing");
        if (fieldIsValid) {
          console.log("isBillingAddressValid==>", validationErrors[fieldName]);
        } else {
          console.table(validationErrors);
          return false; // Exit the function immediately if any field is invalid
        }
      }
      return true; // All fields are valid
    }
    return false;
  };
  const isBillingFormValid = (): boolean => {
    for (const [fieldName, value] of Object.entries(formBillingData)) {
      const fieldIsValid = validateForm(fieldName, value, "billing");
      if (fieldIsValid) {
        console.log("isformBillingDataValid==>", formBillingData[fieldName]);
      } else {
        console.log(
          "validateionErrors isformBillingDataValid==>",
          validationErrors[fieldName],
          formBillingData[fieldName]
        );
        return false; // Exit the function immediately if any field is invalid
      }
    }
    return true; // All fields are valid
  };
  const isShippingAddressValid = (): boolean => {
    if (!isObjectEmpty(formShippingAddress)) {
      for (const [fieldName, value] of Object.entries(formShippingAddress)) {
        const fieldIsValid = validateForm(fieldName, value, "shipping");
        if (fieldIsValid) {
          console.log(
            "isShippingFormDataValid==>",
            formShippingAddress[fieldName]
          );
        } else {
          console.log(
            "validateionErrors isShippingFormDataValid==>",
            validationErrors[fieldName],
            formShippingAddress[fieldName]
          );
          return false; // Exit the function immediately if any field is invalid
        }
      }
      return true; // All fields are valid
    }
    return false;
  };
  const isShippingFormValid = (): boolean => {
    for (const [fieldName, value] of Object.entries(formData)) {
      const fieldIsValid = validateForm(fieldName, value, "shipping");
      if (fieldIsValid) {
        console.log("isShippingFormDataValid==>", formData[fieldName]);
      } else {
        console.log(
          "validateionErrors isShippingFormDataValid==>",
          validationErrors[fieldName],
          formData[fieldName]
        );
        return false; // Exit the function immediately if any field is invalid
      }
    }
    return true; // All fields are valid
  };
  // Define success and error callback functions
  const handleSuccess = (result, pid?) => {
    const locale = window.location.pathname.split("/")[1]; // Extract 'en-us'
    let cartState = result?.cartItems?.cartItem;
    let shippingFlag = sessionStorage.getItem("isShipping");
    setIsDownload(result.isDigital);
    setBrand(result?.brand?.toUpperCase());
    if (shippingFlag && shippingFlag.length) {
      setIsShipping(JSON.parse(shippingFlag));
    }
    if (cartState && cartState.length > 0) {
      const items = cartState.map((cartItem) => ({
        quantity: cartItem.quantity,
        price: {
          basePrice: parseFloat(
            cartItem.pricing.formattedListPrice.replace(currencySign, "")
          ), // Convert to number
          discount: 0, // Assuming no discount information is present
        },
        productInfo: {
          sku: `sku-${cartItem.product.id}`, // Generate SKU from product ID if no SKU exists
          prodID: cartItem.product.id.toString(),
          productName: cartItem.product.name,
        },
      }));

      const formattedLocale = locale
        .replace("-", "_")
        .toLowerCase()
        .replace(/^[a-z]{2}/, (match) => match.toUpperCase());
      const cart = {
        customerID: "",
        orderID: result ? result["cartId"] : "",
        currencyCode: result ? result["pricing"]["orderTotal"]["currency"] : "",
        loginState: nvCookieHelpers.getCookie("isUserLoggedIn")
          ? "loggedIn"
          : "guest",
        storeLocale: formattedLocale,
        promoCode: "no",
        paymentMethod: payment,
        saveCardOption: false, // Assuming this is a boolean
        cardType: payment === "card" ? "creditCard" : "",
        shippingMethod: result ? result["shippingMethod"]["description"] : "",
        items: items,
      };
      if (typeof window !== "undefined") {
        (window as any).CartOrder = cart;
      }
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    console.log((window as any).CartOrder);
    if (result.totalItemsInCart) {
      let billing = result?.billingAddress;
      let shipping = result?.shippingAddress;
      let atts;
      if (result?.customAttributes?.attribute) {
        atts = result.customAttributes.attribute;
      }
      let shippingTo = "residence";
      setCartData(result);
      setIsDirect(result.isDirect);
      setIsPartner(result.partner ? result.partner : false);
      setItemsInCart(result.totalItemsInCart);

      // Use result directly instead of cartData state
      if (result.totalItemsInCart > 0) {
        if (nvCookieHelpers.getCookie("isUserLoggedIn")) {
          navigate(`/${locale}/software/cart/user/loggedIn`);
        } else {
          navigate(`/${locale}/software/cart/user/guest`);
        }
      } else {
        emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
      }

      if (cartState && cartState.length > 0) {
        for (let i = 0; i < cartState.length; i++) {
          const productCustomAttributes =
            cartState[i].product.customAttributes?.attribute;
          if (
            cartState[i].product.productType === "PHYSICALGIFTCARD" &&
            !cartState.isDigital
          ) {
            if (productCustomAttributes) {
              for (let j = 0; j < productCustomAttributes.length; j++) {
                // Check for specific attribute and value
                if (
                  productCustomAttributes[j].name === "isPhysicalGiftCard" &&
                  productCustomAttributes[j].value === "true"
                ) {
                  if (cartState.length === 2) {
                    // Do something with the information
                    let val = JSON.parse(productCustomAttributes[j].value);
                    setPhysicalGiftCard(val);
                    setShippingList([]);
                    setShippingPlace([]);
                    setShippingOptions({ shippingOption: 0, shippingTo: null });
                  }
                } else {
                  setShippingList(result.shippingOptions.shippingOption);
                  if (
                    result.shippingOptions.shippingOption &&
                    result.shippingOptions.shippingOption.length > 0
                  ) {
                    setShippingPlace([
                      { label: "Residence", value: "residence" },
                      { label: "Business", value: "business" },
                      { label: "Education", value: "education" },
                      { label: "Government", value: "government" },
                    ]);
                  }
                }
              }
            }
          } else {
            setShippingList(result.shippingOptions.shippingOption);
            if (
              result.shippingOptions.shippingOption &&
              result.shippingOptions.shippingOption.length > 0
            ) {
              setShippingPlace([
                { label: "Residence", value: "residence" },
                { label: "Business", value: "business" },
                { label: "Education", value: "education" },
                { label: "Government", value: "government" },
              ]);
            }
          }
        }
        if (!result.partner) {
          for (let i = 0; i < atts.length; i++) {
            if (atts[i].name === "shipToCategory") {
              shippingTo = atts[i].value;
            }
          }
        }
        setShippingOptions({
          shippingOption: result.shippingMethod.code,
          shippingTo: shippingTo,
        });
      } else {
        if (nvCookieHelpers.getCookie("isUserLoggedIn")) {
          orderAccount();
        } else {
          handleError("", pid);
        }
      }
      if (nvCookieHelpers.getCookie("isUserLoggedIn")) {
        if (savedBillingAddress && !savedBillingAddress?.length) {
          const addresses = result["addresses"];
          if (addresses?.length && !addresses.some((addr) => addr.isDefault)) {
            addresses[0].isDefault = true;
          }
          setSavedBillingAddress(addresses);
        }
        if (savedShippingAddress && !savedShippingAddress.length) {
          const addresses = result["addresses"];
          if (addresses?.length && !addresses.some((addr) => addr.isDefault)) {
            addresses[0].isDefault = true;
          }
          setSavedShippingAddress(addresses);
        }
        setFormBillingData((prevData) => ({
          ...prevData,
          emailBilling: result?.emailAddress
            ? result?.emailAddress
            : result?.billingAddress[0]?.emailAddress || "",
        }));
      }

      if (result?.billingAddress) {
        const billingData = formFieldsRef.current.billing.data;
        const billingAddress = formFieldsRef.current.billing.address;
        setFormBillingData({
          ...(billing.id ? { id: Number(billing.id) } : {}),
          firstNameBilling: billing.firstName || billingData?.firstNameBilling,
          lastNameBilling: billing.lastName || billingData?.lastNameBilling,
          contactBilling: billing.phoneNumber || billingData?.contactBilling,
          emailBilling: billing.emailAddress || result?.emailAddress || billingData?.emailBilling,
          vemailBilling: billing.emailAddress || result?.emailAddress || billingData?.vemailBilling,
          passwordBilling: "",
          vpasswordBilling: "",
        });
        setFormBillingAddress({
          pincode: billing.postalCode || billingAddress?.pincode,
          address: billing.line1 || billingAddress?.address,
          cityValue: billing.city || billingAddress?.cityValue,
          stateValue:
            (stateDropdown || locale === 'zh-tw') ? (locale === 'zh-tw' ? "TW" : (billing.countrySubdivision || billingAddress?.stateValue)) : billingAddress?.stateValue,
          county: countyField ? billing.county || billingAddress?.county : undefined,
          countryName: billing.countryName || billingAddress?.countryName,
          countryValue: billing.country || billingAddress?.countryValue,
        });
        // Set selected address for billing
        setSelectedBillingAddress({
          ...(billing.id ? { id: Number(billing.id) } : {}),
          city: billing.city || billingAddress?.cityValue,
          countryName: billing.countryName || billingAddress?.countryName,
          country: billing.country || billingAddress?.countryValue,
          firstName: billing.firstName || billingData?.firstNameBilling,
          lastName: billing.lastName || billingData?.lastNameBilling,
          line1: billing.line1 || billingAddress?.address,
          line2: null,
          nickName: "",
          phoneNumber: billing.phoneNumber || billingData?.contactBilling,
          postalCode: billing.postalCode || billingAddress?.pincode,
          countrySubdivision:
            (stateDropdown || locale === 'zh-tw') ? (locale === 'zh-tw' ? "TW" : (billing.countrySubdivision || billingAddress?.stateValue)) : billingAddress?.stateValue,
          county: countyField ? billing.county || billingAddress?.county : undefined,
        });
        if (Number(billing.id) > -1) {
          if (userType === "loggedIn" && savedBillingAddress.length) {
            setIsBillingReadonly(true);
          } else {
            setIsBillingReadonly(false);
          }
        }

        if (
          result?.shippingAddress &&
          shippingFlag &&
          JSON.parse(shippingFlag)
        ) {
          const shippingAddress = formFieldsRef.current.shipping.address;
          const shippingData = formFieldsRef.current.shipping.data;
          setFormData({
            ...(shipping.id ? { id: Number(shipping.id) } : {}),
            firstNameShiping: shipping?.firstName || shippingData?.firstNameShiping,
            lastNameShiping: shipping?.lastName || shippingData?.lastNameShiping,
            contactShiping: shipping?.phoneNumber || shippingData?.contactShiping,
            iBillingFormData: {
              ...(billing.id ? { id: Number(billing.id) } : {}),
              firstNameBilling: billing?.firstName || billingData?.firstNameBilling,
              lastNameBilling: billing?.lastName || billingData?.lastNameBilling,
              contactBilling: billing?.phoneNumber || billingData?.contactBilling,
              emailBilling: billing?.emailAddress || billingData?.emailBilling,
              vemailBilling: billing?.emailAddress || billingData?.vemailBilling,
              passwordBilling: "",
              vpasswordBilling: "",
            },
            iShippingDetails: {
              shippingOption: result.shippingMethod.code,
              shippingTo: shippingTo,
            },
            iBillingFormAddress: {
              pincode: billing?.postalCode || billingAddress?.pincode,
              address: billing?.line1 || billingAddress?.address,
              cityValue: billing?.city || billingAddress?.cityValue,
              stateValue:
                (stateDropdown || locale === 'zh-tw')
                  ? (locale === 'zh-tw' ? "TW" : (billing?.countrySubdivision || billingAddress?.stateValue))
                  : undefined,
              county: countyField ? billing?.county || billingAddress?.county : undefined,
              countryValue: billing?.country || billingAddress?.countryValue,
              countryName: billing?.countryName || billingAddress?.countryName,
            },
            iShippingFormAddress: {
              pincode: shipping.pincode || shippingAddress?.pincode,
              address: shipping.address || shippingAddress?.address,
              cityValue: shipping.city || shippingAddress?.cityValue,
              stateValue:
                locale === "en-us"
                  ? shipping.countrySubdivision || shippingAddress?.stateValue || "-"
                  : undefined,
              county:
                locale !== "en-us"
                  ? shipping.county || shippingAddress?.county || "-"
                  : undefined,
              countryValue: shipping.countryValue || shippingAddress?.countryValue,
              countryName: shipping.countryName || shippingAddress?.countryName,
            },
          });
          setSelectedShippingAddress(
            JSON.parse(shippingFlag) ? shipping : billing
          );

          if (Number(shipping.id) > -1) {
            if (userType === "loggedIn" && savedShippingAddress.length) {
              setIsShippingReadonly(true);
            } else {
              setIsShippingReadonly(false);
            }
          }
        }
      }
      hideBodyLoader();
    } else {
      if (nvCookieHelpers.getCookie("isUserLoggedIn")) {
        orderAccount();
      } else {
        handleError("", pid);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleError = (str: string, pid?: number) => {
    if (pid) {
      if (str && str.length) {
        emptyCart(str, pid);
      } else {
        emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"), pid);
      }
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    setItemsInCart(0);
    hideBodyLoader();
  };
  const handleCouponError = (str: string) => {
    if (str && str.length) {
      emptyCart(str);
    }
    if (couponCode && couponCode.length >= 0) {
      setPromoErr(true);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        promoCode: t("INVALID_PROMO"),
      }));
    } else if (!couponCode) {
      setPromoErr(true);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        promoCode: t("INVALID_PROMO"),
      }));
    } else {
      setPromoErr(false);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        promoCode: "",
      }));
    }
    hideBodyLoader();
  };
  const { RegisterUser } = useAuth();
  const { getCart, updateCart, submitCart, submitPartnerCart, submitAddress } =
    useCart();

  const fetchCart = async () => {
    showBodyLoader();
    await getCart(handleSuccess, handleError, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  useEffect(() => {
    const prevSource = sessionStorage.getItem("payment");
    if (prevSource) {
      setPayment(prevSource);
    } else {
      sessionStorage.setItem("type", payment);
    }
    setShippingPlace([
      { label: "Residence", value: "residence" },
      { label: "Business", value: "business" },
      { label: "Education", value: "education" },
      { label: "Government", value: "government" },
    ]);
    setShippingOptions((prevShippingOptions) => {
      const newShippingOptions = {
        ...prevShippingOptions,
        shippingTo: "residence",
      };
      return newShippingOptions;
    });
    if (orderState) {
      const sessionexpiredID = nvCookieHelpers.getCookie("session_expired");
      if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
        fetchCart();
      } else {
        emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
      }
      hideBodyLoader();
    } else {
      if (sourceId) {
        setIsPartner(JSON.parse(partnerFlag));
        const parsedOrderData = {
          cart: {
            paymentOption: { sourceId: sourceId },
          },
        };
        showBodyLoader();
        if (JSON.parse(partnerFlag)) {
          submitPartnerCart(
            parsedOrderData,
            handlePayPalSuccess,
            handlePayPalError
          );
        } else {
          submitCart(
            JSON.parse(partnerFlag),
            parsedOrderData,
            handlePayPalSuccess,
            handlePayPalError
          );
        }
      } else if (!sourceId && cartData) {
        const parsedFormData = cartData;
        showBodyLoader();

        if (parsedFormData?.billingAddress) {
          let billing = parsedFormData?.billingAddress;
          if (Number(billing.id)) {
            handleSavedBillingAddressChange("savedBillingAddress", "reset");
            setFormBillingData({
              ...(billing.id ? { id: Number(billing.id) } : {}),
              firstNameBilling: billing.firstName || "",
              lastNameBilling: billing.lastName || "",
              contactBilling: billing.phoneNumber || "",
              emailBilling: billing.emailAddress || "",
              vemailBilling: billing.emailAddress || "",
              passwordBilling: "",
              vpasswordBilling: "",
            });
            setFormBillingAddress({
              pincode: billing.postalCode || "",
              address: billing.line1 || "",
              line2: billing.line2 || "",
              cityValue: billing.city || "",
              stateValue:
                (stateDropdown || locale === 'zh-tw')
                  ? (locale === 'zh-tw' ? "TW" : billing.countrySubdivision)
                  : undefined,
              county: countyField ? billing.county || "" : undefined,
              countryName: billing.countryName,
              countryValue: billing.country,
            });
            // Set selected address for billing
            setSelectedBillingAddress({
              city: billing.city || "",
              countryName: billing.countryName,
              country: billing.country,
              firstName: billing.firstName || "",
              lastName: billing.lastName || "",
              line1: billing.line1 || "",
              line2: billing.line2,
              nickName: "",
              phoneNumber: billing.phoneNumber || "",
              postalCode: billing.postalCode || "",
              countrySubdivision: billing.countrySubdivision,
              ...(countyField && { county: billing.county }),
            });
          }
        }
        if (parsedFormData.shippingAddress && parsedFormData.billingAddress) {
          let billing = parsedFormData.billingAddress;
          let shipping = parsedFormData.shippingAddress;
          let atts = parsedFormData.customAttributes.attribute;
          let shippingTo = "residence";
          for (let i = 0; i < atts.length; i++) {
            if (atts[i].name === "shipToCategory") {
              shippingTo = atts[i].value;
            }
          }
          setShippingOptions((prevShippingOptions) => {
            const newShippingOptions = {
              ...prevShippingOptions,
              shippingTo: shippingTo,
            };
            return newShippingOptions;
          });
          setFormData({
            ...(shipping.id ? { id: Number(shipping.id) } : {}),
            firstNameShiping: shipping?.firstName || "",
            lastNameShiping: shipping?.lastName || "",
            contactShiping: shipping?.phoneNumber || "",
            iBillingFormData: {
              ...(billing.id ? { id: Number(billing.id) } : {}),
              firstNameBilling: billing?.firstName,
              lastNameBilling: billing?.lastName,
              contactBilling: billing?.phoneNumber,
              emailBilling: billing?.emailAddress,
              vemailBilling: billing?.emailAddress,
              passwordBilling: "",
              vpasswordBilling: "",
            },
            iShippingDetails: {
              shippingOption: parsedFormData.shippingOptions.shippingOption,
              shippingTo: shippingTo,
            },
            iBillingFormAddress: {
              pincode: billing?.postalCode || "",
              address: billing?.line1 || "",
              line2: billing?.line2 || "",
              cityValue: billing?.city || "",
              stateValue:
                (stateDropdown || locale === 'zh-tw')
                  ? (locale === 'zh-tw' ? "TW" : billing?.countrySubdivision)
                  : undefined,
              county: countyField ? billing?.county || "" : undefined,
              countryValue: billing?.country || "",
              countryName: billing?.countryName || "",
            },
            iShippingFormAddress: {
              pincode: formBillingAddress.pincode,
              address: formBillingAddress.address,
              line2: formBillingAddress.line2,
              cityValue: formBillingAddress.cityValue,
              stateValue: formBillingAddress.stateValue,
              countryName: formBillingAddress.countryName,
              countryValue: formBillingAddress.countryValue,
            },
          });
          // Set selected address for shipping
          setSelectedShippingAddress({
            ...(shipping.id ? { id: Number(shipping.id) } : {}),
            city: shipping.city || "",
            countryName: shipping.countryName,
            country: shipping.country,
            firstName: shipping.firstName || "",
            isDefault: true,
            lastName: shipping.lastName || "",
            line1: shipping.line1 || "",
            line2: shipping.line2 || "",
            nickName: "",
            phoneNumber: shipping.contact || "",
            postalCode: shipping.postalCode || "",
            countrySubdivision:
              (stateDropdown || locale === 'zh-tw')
                ? (locale === 'zh-tw' ? "TW" : shipping.countrySubdivision)
                : undefined,
            county: countyField ? shipping.county || "" : undefined,
          });
          setFormTaxData({
            companyName: "",
            taxAuthority: "",
            startDate: "",
            startYear: "",
            expireDate: "",
            expireYear: "",
            taxFile: null,
          });
        }
      } else if (!cartData) {
        const sessionexpiredID = nvCookieHelpers.getCookie("session_expired");
        if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
          fetchCart();
        } else {
          emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fieldNameRef = useRef<string | null>(null);
  const handleBillingInputChange = (
    fieldName: string,
    value: string | boolean
  ) => {
    setFormBillingData((prevData) => ({ ...prevData, [fieldName]: value }));
    fieldNameRef.current = fieldName;
    setFormData((prevData) => ({
      ...prevData,
      ...(fieldName === "firstNameBilling" &&
        !isShipping &&
        typeof value === "string"
        ? { firstNameShiping: value }
        : {}),
      ...(fieldName === "lastNameBilling" &&
        !isShipping &&
        typeof value === "string"
        ? { lastNameShiping: value }
        : {}),
      ...(fieldName === "contactBilling" &&
        !isShipping &&
        typeof value === "string"
        ? { contactShiping: value }
        : {}),
    }));
  };

  const ucpInitialized = useRef(false);
  const isLoggedIn =
    nvCookieHelpers.getCookie("isUserLoggedIn") === "true" ? true : false;

  // Create refs to store form field values
  const formFieldsRef = useRef<{
    billing: {
      address: intrfce.iAddressFormData | null;
      data: intrfce.iBillingFormData | null;
    };
    shipping: {
      address: intrfce.iAddressFormData | null;
      data: intrfce.iFormContainer | null;
    };
  }>({
    billing: {
      address: null,
      data: null,
    },
    shipping: {
      address: null,
      data: null,
    },
  });

  // Initialize UCP without state updates
  useEffect(() => {
    if (!ucpInitialized.current && cartData && !cartData.zdt) {
      ucpInitialized.current = true;
      let originEnvironment = window.location.origin
        .split("/")[2]
        .split("-")[0]
        ?.toUpperCase();
      originEnvironment =
        originEnvironment !== "STG" && originEnvironment !== "DEV"
          ? "PROD"
          : originEnvironment;

      // Store initial form values in ref
      formFieldsRef.current = {
        billing: {
          address: formBillingAddress,
          data: formBillingData,
        },
        shipping: {
          address: formShippingAddress,
          data: formData,
        },
      };
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        paymentSrc: '',
      }));
      initialize({
        version: "v1",
        environment: originEnvironment,
        clientId: "nvstore",
      })
        .then((Ucp) => {
          if (isLoggedIn && cartData?.idt) {
            window.Ucp?.events?.addEventListener(
              "event-registered-user-payment-methods",
              (event: any) => {
                if (event.detail.message === PaymentEvents.Exists || event.detail.message === PaymentEvents.Changed) {
                  setValidPayment(true);
                  setEnableReviewOrderBtn(true);
                } else if (event.detail.message === PaymentEvents.NotExists) {
                  setEnableReviewOrderBtn(false);
                } else if (event.detail.message === PaymentEvents.Changed) {
                  setEnableReviewOrderBtn(false);
                }
              }
            );
          }
          window.Ucp?.events?.addEventListener(
            "event-guest-payment-method",
            (event: any) => {
              setPaymentEventMessage(event.detail.message);
              if (event.detail.message === PaymentEvents.Valid || event.detail.message === PaymentEvents.Saved) {
                setValidPayment(true);
              }
              switch (event.detail.message) {
                case PaymentEvents.Valid:
                  setSavePayment(false);
                  setEnableReviewOrderBtn(true);
                  break;
                case PaymentEvents.Invalid:
                case PaymentEvents.MissingInput:
                default:
                  setSavePayment(false);
                  setEnableReviewOrderBtn(false);
                  break;
              }
            }
          );

          let initEnvironment =
            originEnvironment === "DEV"
              ? `${originEnvironment}_UE1`
              : originEnvironment;

          const initOptions = {
            ...((!cartData?.idt || !isLoggedIn) && {
              guestSessionId: cartData?.paymentSession?.id,
            }),
            ...(cartData?.idt && isLoggedIn && { token: cartData?.idt }),
            environment: initEnvironment as EnvironmentAPI,
            theme: "light" as Theme,
            nonce: uuidv4(),
            locale: localeWith_,
          };
          Ucp.initialize(initOptions);
        })
        .catch((error) => {
          console.error("Failed to initialize UCP:", error);
        });
    } else {
      setEnableReviewOrderBtn(cartData?.zdt || false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, cartData?.paymentSession?.id, cartData?.idt, isLoggedIn]);

  // Handle form state updates based on payment event
  useEffect(() => {
    if (paymentEventMessage === PaymentEvents.Saved && formFieldsRef.current) {
      const { billing, shipping } = formFieldsRef.current;

      if (billing.address && billing.data) {
        setFormBillingAddress((prevState) => ({
          ...prevState,
          ...billing.address,
        }));

        setFormBillingData((prevState) => ({
          ...prevState,
          ...billing.data,
        }));
      }

      if (shipping.address && shipping.data) {
        setFormShippingAddress((prevState) => ({
          ...prevState,
          ...shipping.address,
        }));

        setFormData((prevState) => ({
          ...prevState,
          ...shipping.data,
        }));
      }

      submitCustomerForm();
      setPaymentEventMessage(null); // Reset the event message
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentEventMessage]);

  // Update ref when form values change
  useEffect(() => {
    if (formBillingAddress && formBillingData) {
      const isEmptyString = (value: any) => {
        return (
          value === undefined ||
          (typeof value === "string" && value.trim() === "")
        );
      };

      const isObjectEmpty = (obj: any) => {
        if (obj === null || obj === undefined || typeof obj !== "object") {
          return isEmptyString(obj);
        }

        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (
              !isObjectEmpty(obj[key]) &&
              obj[key] !== undefined &&
              !isEmptyString(obj[key])
            ) {
              return false;
            }
          }
        }
        return true;
      };

      if (
        !isObjectEmpty(formBillingAddress) &&
        !isObjectEmpty(formBillingData)
      ) {
        formFieldsRef.current.billing = {
          address: formBillingAddress,
          data: formBillingData,
        };
      }
    }
  }, [formBillingAddress, formBillingData]);

  useEffect(() => {
    if (formShippingAddress && formData) {
      const isEmptyString = (value: any) => {
        return typeof value === "string" && value.trim() === "";
      };

      const isObjectEmpty = (obj: any) => {
        if (obj === null || typeof obj !== "object") {
          return isEmptyString(obj);
        }

        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!isObjectEmpty(obj[key]) && !isEmptyString(obj[key])) {
              return false;
            }
          }
        }
        return true;
      };

      if (!isObjectEmpty(formShippingAddress) && !isObjectEmpty(formData)) {
        formFieldsRef.current.shipping = {
          address: formShippingAddress,
          data: formData,
        };
      }
    }
  }, [formShippingAddress, formData]);

  useEffect(() => {
    // This will be executed after the state has been updated
    let fieldName = fieldNameRef.current;
    if (fieldName) {
      validateForm(fieldName, formBillingData[fieldName], "billing");
    }
    // Ensure selectedBillingAddress is of type iSavedAddress before accessing properties
    if (selectedBillingAddress && selectedBillingAddress !== RESET_ADDRESS) {
      const address = selectedBillingAddress as intrfce.iSavedAddress;
      setFormData((prevData) => ({
        ...prevData,
        iBillingFormData: {
          ...(address.id ? { id: Number(address.id) } : {}),
          firstNameBilling: address.firstName,
          lastNameBilling: address.lastName,
          contactBilling: address.phoneNumber,
          emailBilling: formBillingData.emailBilling,
          vemailBilling: formBillingData.vemailBilling,
          passwordBilling: formBillingData.passwordBilling,
          vpasswordBilling: formBillingData.vpasswordBilling,
        },
        iBillingFormAddress: {
          pincode: address.postalCode,
          address: address.line1,
          line2: address.line2 || "",
          cityValue: address.city,
          stateValue:
            (stateDropdown || locale === 'zh-tw') ? (locale === 'zh-tw' ? "TW" : address.countrySubdivision) : undefined,
          county: countyField ? address.county || "-" : undefined,
          countryValue: address.country,
          countryName: address.countryName,
        },
        iShippingDetails: {
          shippingOption: shippingOptions.shippingOption,
          shippingTo: shippingOptions.shippingTo,
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        firstNameShiping: isShipping
          ? formData.firstNameShiping
          : formBillingData.firstNameBilling,
        lastNameShiping: isShipping
          ? formData.lastNameShiping
          : formBillingData.lastNameBilling,
        contactShiping: isShipping
          ? formData.contactShiping
          : formBillingData.contactBilling,
        iBillingFormAddress: formBillingAddress,
        iBillingFormData: {
          firstNameBilling: formBillingData.firstNameBilling,
          lastNameBilling: formBillingData.lastNameBilling,
          contactBilling: formBillingData.contactBilling,
          ...(nvCookieHelpers.getCookie("isUserLoggedIn")
            ? { emailBilling: cartData?.emailAddress || "" }
            : { emailBilling: formBillingData.emailBilling || "" }),
          ...(nvCookieHelpers.getCookie("isUserLoggedIn")
            ? { vemailBilling: cartData?.emailAddress || "" }
            : { vemailBilling: formBillingData.emailBilling || "" }),
        },
        ...(!isShipping
          ? { iShippingFormAddress: formBillingAddress }
          : {
            iShippingFormAddress: {
              pincode: formShippingAddress.pincode,
              address: formShippingAddress.address,
              cityValue: formShippingAddress.cityValue,
              stateValue:
                locale === "en-us"
                  ? formShippingAddress.stateValue || "-"
                  : undefined,
              county:
                locale !== "en-us"
                  ? formShippingAddress.county || "-"
                  : undefined,
              countryValue: formShippingAddress.countryValue,
              countryName: formShippingAddress.countryName,
            },
          }),
        iShippingDetails: {
          shippingOption: shippingOptions["shippingOption"],
          shippingTo: shippingOptions["shippingTo"],
        },
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateForm, isShipping]);

  useEffect(() => {
    // This will be executed after the state has been updated
    let fieldName = fieldNameRef.current;
    if (fieldName) {
      validateForm(fieldName, formTaxData[fieldName], "billing");
    }
  }, [formTaxData, validateForm]);
  const isEmptyAddress = (address: any): boolean => {
    if (address) {
      const keysToCheck = [
        "city",
        "country",
        "countryName",
        "countrySubdivision",
        "firstName",
        "isDefault",
        "lastName",
        "line1",
        "line2",
        "nickName",
        "phoneNumber",
        "postalCode",
      ];
      return (
        address.id === -1 &&
        keysToCheck.every(
          (key) =>
            address[key] === "" ||
            address[key] === false ||
            address[key] === null ||
            address[key] === undefined ||
            address[key] === t("ADD_NEW_ADDRESS")
        )
      );
    } else {
      return false;
    }
  };
  useEffect(() => {
    let isNewBillingAddressExists: intrfce.iSavedAddress | undefined;
    let isNewShippingAddressExists: intrfce.iSavedAddress | undefined;
    let isBillingAddressEmpty: boolean = false;
    let isShippingAddressEmpty: boolean = false;
    let updatedBillingAddresses: intrfce.iSavedAddress[] | undefined;
    let updatedShippingAddresses: intrfce.iSavedAddress[] | undefined;
    let shippingAddressArray: intrfce.iSavedAddress[];
    let billingAddressArray: intrfce.iSavedAddress[];
    let newBillingAddressId: any;
    let newShippingAddressId: any;
    let defaultBillingAddress: any;
    let defaultShippingAddress: any;
    let newShippingAddress: any;
    let newBillingAddress: any;
    console.log("selectedBillingAddress==>", selectedBillingAddress);
    if (typeof selectedBillingAddress !== "string") {
      isBillingAddressEmpty = isEmptyAddress(selectedBillingAddress);
    }
    if (typeof selectedShippingAddress !== "string") {
      isShippingAddressEmpty = isEmptyAddress(selectedShippingAddress);
    }

    if (
      savedBillingAddress &&
      savedBillingAddress.length &&
      savedShippingAddress &&
      savedShippingAddress.length
    ) {
      billingAddressArray = updatedBillingAddresses?.length
        ? updatedBillingAddresses
        : savedBillingAddress;
      shippingAddressArray = updatedShippingAddresses?.length
        ? updatedShippingAddresses
        : savedShippingAddress;

      isNewBillingAddressExists = billingAddressArray.find(
        (addr) => Number(addr.id) <= 0
      );
      isNewShippingAddressExists = shippingAddressArray.find(
        (addr) => Number(addr.id) <= 0
      );
      if (
        typeof selectedBillingAddress === "string" ||
        typeof selectedShippingAddress === "string"
      ) {
        if (typeof selectedBillingAddress === "string") {
          newBillingAddress = {
            id: -1,
            city: "",
            country: "",
            countryName: "",
            ...((stateDropdown || locale === 'zh-tw') && { countrySubdivision: locale === 'zh-tw' ? "TW" : "" }),
            ...(countyField && { county: "" }),
            firstName: "",
            isDefault: true,
            lastName: "",
            line1: "",
            line2: "",
            nickName: t("ADD_NEW_ADDRESS"),
            phoneNumber: "",
            postalCode: "",
          };
          newBillingAddressId = newBillingAddress.id;
          const existingBillingAddress = billingAddressArray.find(
            (addr) => addr.id === -1
          );
          if (!existingBillingAddress) {
            updatedBillingAddresses = [
              newBillingAddress,
              ...savedBillingAddress,
            ];
            setSavedBillingAddress(updatedBillingAddresses);
            if (!isShipping) {
              updatedShippingAddresses = [
                newBillingAddress,
                ...savedShippingAddress,
              ];
              setSavedShippingAddress(updatedShippingAddresses);
            }
          } else {
            updatedBillingAddresses = savedBillingAddress;
          }
          setSelectedBillingAddress(newBillingAddress);
        } else {
          if (selectedBillingAddress) {
            newBillingAddressId = selectedBillingAddress["id"];
          }
        }
        if (isShipping && typeof selectedShippingAddress === "string") {
          newShippingAddress = {
            id: -1,
            city: "",
            country: "",
            countryName: "",
            ...((stateDropdown || locale === 'zh-tw') && { countrySubdivision: locale === 'zh-tw' ? "TW" : "" }),
            ...(countyField && { county: "" }),
            firstName: "",
            isDefault: true,
            lastName: "",
            line1: "",
            line2: "",
            nickName: t("ADD_NEW_ADDRESS"),
            phoneNumber: "",
            postalCode: "",
          };
          newShippingAddressId = newShippingAddress.id;
          const existingShippingAddress = shippingAddressArray.find(
            (addr) => addr.id === -1
          );
          if (!existingShippingAddress) {
            updatedShippingAddresses = [
              newShippingAddress,
              ...savedShippingAddress,
            ];
            setSavedShippingAddress(updatedShippingAddresses);
          } else {
            updatedShippingAddresses = savedShippingAddress;
          }
          setSelectedShippingAddress(newShippingAddress);
        } else {
          if (selectedShippingAddress) {
            newShippingAddressId = selectedShippingAddress["id"];
          }
        }
      } else if (
        cartData &&
        (cartData.billingAddress?.id === -1 ||
          cartData.shippingAddress?.id === -1 ||
          cartData.billingAddress?.id === "0" ||
          cartData.shippingAddress?.id === "0")
      ) {
        if (isShipping) {
          if (
            !isNewShippingAddressExists &&
            !isShippingAddressEmpty &&
            !(Number(cartData.shippingAddress?.id) > 0)
          ) {
            newShippingAddress = {
              ...cartData.shippingAddress,
              id: Number(cartData.shippingAddress.id),
              isDefault: false,
              nickName: "Order Address",
              line2: cartData.shippingAddress.line2 || "",
              city: cartData.shippingAddress.city || "",
              country: cartData.shippingAddress.country || "",
              countryName: cartData.shippingAddress.countryName || "",
              ...((stateDropdown || locale === 'zh-tw') && {
                countrySubdivision:
                  (locale === 'zh-tw' ? "TW" : cartData.shippingAddress.countrySubdivision) || "",
              }),
              ...(countyField && {
                county: cartData.shippingAddress.county || "",
              }),
              firstName: cartData.shippingAddress.firstName || "",
              lastName: cartData.shippingAddress.lastName || "",
              line1: cartData.shippingAddress.line1 || "",
              phoneNumber: cartData.shippingAddress.phoneNumber || "",
              postalCode: cartData.shippingAddress.postalCode || "",
            };
            updatedShippingAddresses = [
              newShippingAddress,
              ...savedShippingAddress,
            ];
            setSavedShippingAddress(updatedShippingAddresses);
            newShippingAddressId = newShippingAddress.id;
          } else {
            if (
              typeof selectedShippingAddress !== "string" &&
              selectedShippingAddress?.id !==
              Number(cartData.shippingAddress.id)
            ) {
              newShippingAddress = shippingAddressArray.find(
                (addr) => addr.id === Number(selectedShippingAddress?.id)
              );
            } else {
              newShippingAddress = shippingAddressArray.find(
                (addr) => addr.id === Number(cartData.shippingAddress?.id)
              );
            }
            if (newShippingAddress && !isShippingAddressEmpty) {
              newShippingAddressId = isShipping
                ? newShippingAddress.id
                : selectedBillingAddress?.id;
            } else {
              newShippingAddressId = "reset";
            }
          }
        }

        if (
          !isNewBillingAddressExists &&
          !isBillingAddressEmpty &&
          !(Number(cartData.billingAddress?.id) > 0)
        ) {
          newBillingAddress = {
            ...cartData.billingAddress,
            id: Number(cartData.billingAddress.id),
            isDefault: false,
            nickName: "Order Address",
            line2: cartData.billingAddress.line2 || "",
            city: cartData.billingAddress.city || "",
            country: cartData.billingAddress.country || "",
            countryName: cartData.billingAddress.countryName || "",
            ...((stateDropdown || locale === 'zh-tw') && {
              countrySubdivision:
                (locale === 'zh-tw' ? "TW" : cartData.billingAddress.countrySubdivision) || "",
            }),
            ...(countyField && {
              county: cartData.billingAddress.county || "",
            }),
            firstName: cartData.billingAddress.firstName || "",
            lastName: cartData.billingAddress.lastName || "",
            line1: cartData.billingAddress.line1 || "",
            phoneNumber: cartData.billingAddress.phoneNumber || "",
            postalCode: cartData.billingAddress.postalCode || "",
          };
          updatedBillingAddresses = [newBillingAddress, ...savedBillingAddress];
          setSavedBillingAddress(updatedBillingAddresses);
          if (!isShipping) {
            updatedShippingAddresses = [
              newBillingAddress,
              ...savedShippingAddress,
            ];
            setSavedShippingAddress(updatedShippingAddresses);
          }
          newBillingAddressId = newBillingAddress.id;
        } else {
          if (
            typeof selectedBillingAddress !== "string" &&
            selectedBillingAddress?.id !== Number(cartData.billingAddress.id)
          ) {
            newBillingAddress = billingAddressArray.find(
              (addr) => addr.id === Number(selectedBillingAddress?.id)
            );
          } else {
            newBillingAddress = billingAddressArray.find(
              (addr) => addr.id === Number(cartData.billingAddress?.id)
            );
          }
          if (newBillingAddress && !isBillingAddressEmpty) {
            newBillingAddressId = newBillingAddress.id;
          } else {
            newBillingAddressId = "reset";
          }
        }
      } else if (isBillingAddressEmpty || isShippingAddressEmpty) {
        console.log(selectedBillingAddress);
        if (isBillingAddressEmpty) {
          newBillingAddressId = "reset";
        } else {
          if (typeof selectedBillingAddress !== "string") {
            newBillingAddressId = selectedBillingAddress?.id;
          }
        }
        if (isShippingAddressEmpty) {
          newShippingAddressId = "reset";
        } else {
          if (typeof selectedShippingAddress !== "string") {
            newShippingAddressId = selectedShippingAddress?.id;
          }
        }
      } else if (
        typeof selectedBillingAddress !== "string" &&
        typeof selectedShippingAddress !== "string" &&
        selectedShippingAddress?.id !== undefined &&
        selectedShippingAddress?.id !== null &&
        selectedBillingAddress?.id !== undefined &&
        selectedBillingAddress?.id !== null
      ) {
        if (
          isShipping &&
          typeof selectedShippingAddress !== "string" &&
          selectedShippingAddress.id === formData?.id
        ) {
          isNewShippingAddressExists = shippingAddressArray.find(
            (addr) => Number(addr.id) === selectedShippingAddress?.id
          );
          newShippingAddressId = isNewShippingAddressExists?.id;
        } else {
          newShippingAddressId = selectedShippingAddress?.id;
        }
        if (
          typeof selectedBillingAddress !== "string" &&
          selectedBillingAddress.id === formBillingData?.id
        ) {
          isNewBillingAddressExists = billingAddressArray.find(
            (addr) => Number(addr.id) === selectedBillingAddress?.id
          );
          newBillingAddressId = isNewBillingAddressExists?.id;
        } else {
          newBillingAddressId = selectedBillingAddress?.id;
        }
      } else {
        isNewBillingAddressExists = billingAddressArray.find(
          (addr) => addr.id === Number(cartData?.billingAddress?.id)
        );
        if (!isNewBillingAddressExists) {
          isNewBillingAddressExists = billingAddressArray.find(
            (addr) => addr.id === -1
          );
          if (!isNewBillingAddressExists && selectedBillingAddress) {
            isNewBillingAddressExists = billingAddressArray.find(
              (addr) => addr.id === Number(selectedBillingAddress.id)
            );
          }
        }
        newBillingAddressId = isNewBillingAddressExists?.id;

        isNewShippingAddressExists = shippingAddressArray.find(
          (addr) => addr.id === Number(cartData?.shippingAddress?.id)
        );
        if (!isNewShippingAddressExists) {
          isNewShippingAddressExists = shippingAddressArray.find(
            (addr) => addr.id === -1
          );
          if (!isNewShippingAddressExists && selectedShippingAddress) {
            isNewShippingAddressExists = shippingAddressArray.find(
              (addr) => addr.id === Number(selectedShippingAddress.id)
            );
          }
        }
        newShippingAddressId = isNewShippingAddressExists?.id;
      }
    }

    // Billing Address Logic
    if (
      savedBillingAddress &&
      savedBillingAddress.length &&
      userType === "loggedIn"
    ) {
      defaultBillingAddress = savedBillingAddress.find(
        (addr) => addr.isDefault
      );
      const billingAddressIdToUse =
        newBillingAddressId !== undefined
          ? newBillingAddressId
          : defaultBillingAddress?.id;
      if (
        billingAddressIdToUse !== undefined &&
        billingAddressIdToUse !== "reset" &&
        typeof selectedBillingAddress !== "string"
      ) {
        handleSavedBillingAddressChange(
          "savedBillingAddress",
          billingAddressIdToUse,
          updatedBillingAddresses
        );
      }
    }

    // Shipping Address Logic
    if (
      savedShippingAddress &&
      savedShippingAddress.length &&
      userType === "loggedIn"
    ) {
      defaultShippingAddress = savedShippingAddress.find(
        (addr) => addr.isDefault
      );
      const shippingAddressIdToUse =
        newShippingAddressId !== undefined
          ? newShippingAddressId
          : defaultShippingAddress?.id;
      if (
        shippingAddressIdToUse !== undefined &&
        typeof selectedShippingAddress !== "string" &&
        shippingAddressIdToUse !== "reset"
      ) {
        handleSavedShippingAddressChange(
          "savedShippingAddress",
          shippingAddressIdToUse,
          updatedShippingAddresses
        );
      }
    }

    // If isShipping is false, use the same logic for billing and shipping
    if (
      !isShipping &&
      savedBillingAddress &&
      savedBillingAddress.length &&
      savedShippingAddress &&
      savedShippingAddress.length &&
      userType === "loggedIn"
    ) {
      const defaultAddress = savedBillingAddress.find((addr) => addr.isDefault);
      const addressIdToUse =
        newBillingAddressId !== undefined
          ? newBillingAddressId
          : defaultAddress?.id;

      if (
        addressIdToUse !== undefined &&
        addressIdToUse !== "reset" &&
        typeof selectedBillingAddress !== "string" &&
        selectedBillingAddress?.id !== addressIdToUse
      ) {
        handleSavedBillingAddressChange(
          "savedBillingAddress",
          addressIdToUse,
          updatedBillingAddresses
        );
        handleSavedShippingAddressChange(
          "savedShippingAddress",
          addressIdToUse,
          updatedShippingAddresses
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    savedBillingAddress,
    savedShippingAddress,
    selectedBillingAddress,
    selectedShippingAddress,
    isShipping,
    cartData,
  ]);

  const handleSavedShippingAddressChange = (
    fieldName: string,
    selectedValue: any,
    addrArr?: any
  ) => {
    console.log("handleSavedShippingAddressChange==>", selectedValue);
    if (selectedValue === "reset") {
      setIsShippingReadonly(false);
      setFormShippingAddress({
        pincode: "",
        address: "",
        line2: "",
        cityValue: "",
        stateValue: "",
        countryName: "",
        countryValue: "",
      });
      setFormData((prevData) => {
        const { id, ...rest } = prevData;
        return {
          ...rest,
          firstNameShiping: "",
          lastNameShiping: "",
          contactShiping: "",
          iShippingFormAddress: {
            pincode: "",
            address: "",
            line2: "",
            cityValue: "",
            stateValue: "",
            countryValue: "",
            countryName: "",
          },
        };
      });
      // Always set selectedShippingAddress to 'reset'
      setSelectedShippingAddress(selectedValue);

      // Check for objects with id === -1 in savedShippingAddress and make their values blank
      if (savedShippingAddress && savedShippingAddress.length) {
        setSavedShippingAddress((prev) => {
          return prev.map((addr) => {
            if (addr.id === -1) {
              // Create a blank address object with the same structure
              return {
                id: -1,
                city: "",
                countryName: "United States",
                country: "US",
                firstName: "",
                lastName: "",
                line1: "",
                line2: "",
                nickName: t("ADD_NEW_ADDRESS"),
                phoneNumber: "",
                postalCode: "",
                countrySubdivision: "",
                isDefault: false,
              };
            }
            return addr;
          });
        });
      }
    } else {
      const addresses = addrArr ? addrArr : savedShippingAddress;
      let selectedAddress = addresses?.filter(
        (ship) => ship.id === Number(selectedValue)
      );
      let updatedAddress;
      if (selectedAddress) {
        updatedAddress = selectedAddress[0];
        setSelectedShippingAddress(updatedAddress);
        if (updatedAddress) {
          setFormShippingAddress({
            pincode: updatedAddress?.postalCode || "",
            address: updatedAddress?.line1 || "",
            line2: updatedAddress?.line2 || "",
            cityValue: updatedAddress?.city || "",
            stateValue:
              (stateDropdown || locale === 'zh-tw')
                ? (locale === 'zh-tw' ? "TW" : updatedAddress?.countrySubdivision)
                : undefined,
            county:
              countyField ? updatedAddress?.county || "" : undefined,
            countryName: updatedAddress?.countryName || "",
            countryValue: updatedAddress?.country || "",
          });
          setFormData((prevData) => ({
            ...prevData,
            ...(updatedAddress.id ? { id: Number(updatedAddress.id) } : {}),
            firstNameShiping: updatedAddress?.firstName || "",
            lastNameShiping: updatedAddress?.lastName || "",
            contactShiping: updatedAddress?.phoneNumber || "",
            iShippingFormAddress: {
              ...prevData.iShippingFormAddress, // Spread existing iShippingFormAddress properties
              pincode: updatedAddress?.postalCode || "",
              address: updatedAddress?.line1 || "",
              cityValue: updatedAddress?.city || "",
              stateValue:
                (stateDropdown || locale === 'zh-tw')
                  ? (locale === 'zh-tw' ? "TW" : updatedAddress?.countrySubdivision)
                  : undefined,
              county:
                countyField ? updatedAddress?.county || "" : undefined,
              countryValue: updatedAddress?.country || "",
              countryName: updatedAddress?.countryName || "",
            },
          }));
        }
        if (Number(selectedValue) === 0 || Number(selectedValue) === -1) {
          setIsShippingReadonly(false);
        } else {
          setIsShippingReadonly(userType === "loggedIn");
        }
      }
    }
  };
  const handleSavedBillingAddressChange = (
    fieldName: string,
    selectedValue: any,
    addrArr?: any
  ) => {
    console.log("handleSavedBillingAddressChange==>", selectedValue);
    if (selectedValue === "reset") {
      setIsBillingReadonly(false);
      setFormBillingAddress({
        pincode: "",
        address: "",
        cityValue: "",
        stateValue: "",
        county: "",
        countryName: countries[0]?.countryName || "",
        countryValue: countries[0]?.ISO_CC || "",
      });
      setFormBillingData({
        firstNameBilling: "",
        lastNameBilling: "",
        contactBilling: "",
        emailBilling: cartData?.emailAddress || "",
        vemailBilling: "",
        passwordBilling: "",
        vpasswordBilling: "",
      });
      setSelectedBillingAddress(selectedValue);
      if (!isShipping) {
        handleSavedShippingAddressChange("savedShippingAddress", selectedValue);
      }
    } else {
      const addresses = addrArr ? addrArr : savedBillingAddress;
      if (selectedValue < 0) {
        setFormBillingData({
          ...(formBillingData.id ? { id: Number(formBillingData.id) } : {}),
          firstNameBilling: formBillingData?.firstNameBilling || "",
          lastNameBilling: formBillingData?.lastNameBilling || "",
          contactBilling: formBillingData?.contactBilling || "",
          emailBilling:
            cartData?.emailAddress || formBillingData?.emailBilling || "",
          vemailBilling: "",
          passwordBilling: "",
          vpasswordBilling: "",
        });

        if (!isShipping) {
          setFormShippingAddress(formBillingAddress);
          setFormData((prevData) => ({
            ...prevData,
            iShippingFormAddress: {
              ...formBillingAddress,
              firstNameShiping: formBillingData?.firstNameBilling || "",
              lastNameShiping: formBillingData?.lastNameBilling || "",
              contactShiping: formBillingData?.contactBilling || "",
            },
          }));
        }
      } else {
        const selectedAddress = addresses?.filter(
          (bill) => bill.id === Number(selectedValue)
        );
        if (selectedAddress) {
          let updatedAddress = selectedAddress[0];
          setSelectedBillingAddress(updatedAddress);
          console.log("handleSavedBillingAddressChange==>", fieldName);
          // Find the selected address based on the nickname
          // Update formBillingAddress with the selected address values
          if (updatedAddress) {
            setFormBillingAddress({
              pincode: updatedAddress?.postalCode || "",
              address: updatedAddress?.line1 || "",
              cityValue: updatedAddress?.city || "",
              stateValue: updatedAddress?.countrySubdivision || "",
              line2: updatedAddress?.line2 || "",
              countryName: updatedAddress?.countryName || "",
              countryValue: updatedAddress?.country || "",
            });
            setFormBillingData({
              ...(updatedAddress.id ? { id: Number(updatedAddress.id) } : {}),
              firstNameBilling: updatedAddress?.firstName || "",
              lastNameBilling: updatedAddress?.lastName || "",
              contactBilling: updatedAddress?.phoneNumber || "",
              emailBilling: cartData?.emailAddress || "",
              vemailBilling: "",
              passwordBilling: "",
              vpasswordBilling: "",
            });
            setFormData((prevData) => ({
              ...prevData,
              iBillingFormData: {
                ...prevData.iBillingFormData,
                ...(updatedAddress.id ? { id: Number(updatedAddress.id) } : {}),
                firstNameBilling: updatedAddress?.firstName || "",
                lastNameBilling: updatedAddress?.lastName || "",
                contactBilling: updatedAddress?.phoneNumber || "",
                emailBilling: cartData?.emailAddress || "",
                vemailBilling: "",
                passwordBilling: "",
                vpasswordBilling: "",
              },
              iBillingFormAddress: {
                ...prevData.iBillingFormAddress,
                pincode: updatedAddress?.postalCode || "",
                address: updatedAddress?.line1 || "",
                line2: updatedAddress?.line2 || "",
                cityValue: updatedAddress?.city || "",
                stateValue: updatedAddress?.countrySubdivision || "",
                countryValue: updatedAddress?.country || "",
                countryName: updatedAddress?.countryName || "",
              },
            }));
            if (Number(selectedValue) === 0 || Number(selectedValue) === -1) {
              setIsBillingReadonly(false);
            } else {
              setIsBillingReadonly(userType === "loggedIn");
            }
            Object.keys(formBillingData).forEach((fieldName) => {
              if (
                formBillingData[fieldName] &&
                formBillingData[fieldName].length
              ) {
                validateForm(fieldName, formBillingData[fieldName], "billing");
              }
            });
            Object.keys(formBillingAddress).forEach((fieldName) => {
              if (
                formBillingAddress[fieldName] &&
                formBillingAddress[fieldName].length
              ) {
                validateForm(
                  fieldName,
                  formBillingAddress[fieldName],
                  "billing"
                );
              }
            });
          }
        }
      }
    }
  };
  const handleInputChange = (fieldName: string, value: string) => {
    fieldNameRef.current = fieldName;
    setFormData((prevState) => ({ ...prevState, [fieldName]: value }));
    validateForm(fieldName, value, "shipping");
  };
  const shipingInfo = `shipingInfo ${isShipping ? " visible" : ""}`;
  useEffect(() => {
    // This will be executed after the state has been updated
    let fieldName = fieldNameRef.current;
    if (fieldName) {
      validateForm(fieldName, formData[fieldName], "shipping");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);
  const handleCartChange = async (
    productId?: string,
    selectedOption?: number,
    shippingOption?: string,
    coupon?: string,
    couponApplied?: boolean
  ) => {
    showCartLoader();
    if (productId && selectedOption !== undefined && selectedOption !== null) {
      await updateCart(
        handleSuccess,
        handleError,
        productId,
        selectedOption,
        isDownload,
        shippingOption,
        undefined,
        undefined,
        false
      );
    } else if (shippingOption !== undefined && shippingOption !== null) {
      await updateCart(
        handleSuccess,
        handleError,
        undefined,
        undefined,
        isDownload,
        shippingOption,
        undefined,
        undefined,
        false
      );
    } else {
      if (coupon) {
        await updateCart(
          handleSuccess,
          handleCouponError,
          undefined,
          undefined,
          isDownload,
          undefined,
          coupon,
          undefined,
          false
        );
      } else {
        if (couponApplied) {
          await updateCart(
            handleSuccess,
            handleCouponError,
            undefined,
            undefined,
            isDownload,
            undefined,
            undefined,
            undefined,
            couponApplied
          );
        }
      }
    }
    hideCartLoader();
  };

  const handleCouponChange = (fieldName: string, promo: string | null) => {
    fieldNameRef.current = fieldName;
    setCoupon(promo);
    if (promo || promo?.length === 0) {
      setPromoErr(false);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        promoCode: "",
      }));
    }
    console.log("promo==>", promo);
  };

  const handleCouponDelete = (d: boolean) => {
    handleCartChange(undefined, undefined, undefined, undefined, d);
  };
  const handleCouponSubmit = (c: string) => {
    handleCartChange(undefined, undefined, undefined, c);
  };

  const handleisShippingChange = (
    e: ChangeEvent<HTMLElement> | React.MouseEvent<HTMLButtonElement>,
    shippingState?: boolean
  ) => {
    setIsShipping(shippingState ?? !isShipping);
    sessionStorage.setItem("isShipping", JSON.stringify(!isShipping));
    setFormShippingAddress(formBillingAddress);
    if (
      isShipping &&
      savedShippingAddress &&
      savedShippingAddress.length &&
      !selectedShippingAddress &&
      userType === "loggedIn"
    ) {
      // Find the default address if available
      const defaultAddress =
        formBillingData && formBillingData.id
          ? formBillingData
          : savedShippingAddress.find((addr) => addr.isDefault);
      if (defaultAddress) {
        handleSavedShippingAddressChange(
          "savedShippingAddress",
          JSON.stringify(defaultAddress.id)
        );
      }
    } else {
      let billingAddressCopy = {
        city: formBillingAddress.cityValue || "",
        countryName: formBillingAddress.countryName,
        country: formBillingAddress.countryValue,
        firstName: formBillingData.firstNameBilling,
        lastName: formBillingData.lastNameBilling,
        line1: formBillingAddress.address || "",
        line2: formBillingAddress.line2 || "",
        nickName: t("ADD_NEW_ADDRESS"),
        phoneNumber: formBillingData.contactBilling,
        ...(formBillingData.id ? { id: Number(formBillingData.id) } : {}),
        ...(selectedBillingAddress !== "reset"
          ? { id: Number(selectedBillingAddress?.id) }
          : {}),
        postalCode: formBillingAddress.pincode || "",
        countrySubdivision: formBillingAddress.stateValue,
      };

      // Check if the ID already exists in savedShippingAddress and update it
      if (
        billingAddressCopy.id &&
        savedShippingAddress &&
        savedShippingAddress.length
      ) {
        setSavedShippingAddress((prev) => {
          const index = prev.findIndex(
            (addr) => addr.id === billingAddressCopy.id
          );
          if (index !== -1) {
            // Replace existing object with the same ID
            const newArray = [...prev];
            newArray[index] = billingAddressCopy;
            return newArray;
          }
          // If no object with this ID exists, add the new one
          return [...prev, billingAddressCopy];
        });
      }

      setSelectedShippingAddress(billingAddressCopy);
    }
    setFormData((prevData) => ({
      ...prevData,
      ...(selectedBillingAddress !== "reset"
        ? { id: Number(selectedBillingAddress?.id) }
        : {}),
      firstNameShiping: formBillingData.firstNameBilling,
      lastNameShiping: formBillingData.lastNameBilling,
      contactShiping: formBillingData.contactBilling,
      iShippingFormAddress: {
        ...prevData.iShippingFormAddress,
        pincode: formBillingAddress.pincode,
        address: formBillingAddress.address,
        cityValue: formBillingAddress.cityValue,
        line2: formBillingAddress.line2 || "",
        stateValue: formBillingAddress.stateValue || "-",
        countryName: formBillingAddress.countryName,
        countryValue: formBillingAddress.countryValue,
      },
    }));
  };
  const billaddr = {
    ...(formBillingData.id ? { id: Number(formBillingData.id) } : {}),
    firstName: formBillingData.firstNameBilling || "",
    lastName: formBillingData.lastNameBilling || "",
    line1: formBillingAddress.address || "",
    line2: formBillingAddress.line2 || "",
    city: formBillingAddress.cityValue || "",
    countrySubdivision: (stateDropdown || locale === 'zh-tw') ? (locale === 'zh-tw' ? "TW" : formBillingAddress.stateValue) : "",
    county: countyField ? formBillingAddress.county : "",
    postalCode: formBillingAddress.pincode || "",
    country: formBillingAddress.countryValue || "",
    countryName: formBillingAddress.countryName || "",
    emailAddress:
      formBillingData?.emailBilling || cartData?.emailAddress || undefined,
    phoneNumber: formBillingData.contactBilling || "",
  };
  const shipaddr = {
    ...(isShipping
      ? formData.id
        ? { id: Number(formData.id) }
        : {}
      : formBillingData.id
        ? { id: Number(formBillingData.id) }
        : {}),
    firstName: isShipping
      ? formData.firstNameShiping
      : formBillingData.firstNameBilling || "",
    lastName: isShipping
      ? formData.lastNameShiping
      : formBillingData.lastNameBilling || "",
    line1: isShipping
      ? formShippingAddress.address
      : formBillingAddress.address || "",
    line2: isShipping
      ? formShippingAddress.line2
      : formBillingAddress.line2 || "",
    city: isShipping
      ? formShippingAddress.cityValue
      : formBillingAddress.cityValue || "",
    countrySubdivision:
      (stateDropdown || locale === 'zh-tw')
        ? (locale === 'zh-tw' ? "TW" : isShipping
          ? formShippingAddress.stateValue
          : formBillingAddress.stateValue)
        : "",
    county:
      countyField
        ? isShipping
          ? formShippingAddress.county
          : formBillingAddress.county
        : "",
    postalCode: isShipping
      ? formShippingAddress.pincode
      : formBillingAddress.pincode || "",
    country: isShipping
      ? formShippingAddress.countryValue
      : formBillingAddress.countryValue || "",
    countryName: isShipping
      ? formShippingAddress.countryName
      : formBillingAddress.countryName || "",
    emailAddress: isShipping
      ? formBillingData?.emailBilling
      : formBillingData?.emailBilling || cartData?.emailAddress || undefined,
    phoneNumber: isShipping
      ? formData.contactShiping
      : formBillingData.contactBilling || "",
  };
  const shipopt = shippingOptions?.shippingOption?.toString();

  const taxExemptObj = {
    companyName: formTaxData.companyName,
    taxAuthority: formTaxData.taxAuthority,
    startDate: "01/" + formTaxData.startDate + "/" + formTaxData.startYear,
    endDate: "28/" + formTaxData.expireDate + "/" + formTaxData.expireYear,
  };
  useEffect(() => {
    isBillingAddressValid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formBillingAddress]);
  useEffect(() => {
    isShippingAddressValid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formShippingAddress]);
  useEffect(() => {
    setOrder((prevData) => ({
      ...prevData,
      cart: {
        futureUse: true,
        billingAddress: billaddr,
        shippingAddress: shipaddr,
        shippingOptionId: shipopt,
        taxExemption: taxExemptObj,
        customAttributes: {
          attribute: [
            {
              name: "shipToCategory",
              value: shippingOptions.shippingTo,
            },
          ],
        },
      },
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formBillingData,
    formBillingAddress,
    formData,
    formShippingAddress,
    shippingOptions,
    formTaxData,
  ]);

  const handleShippingMethodChange = (fieldName: string, value: string) => {
    // Use the callback function to ensure the state is updated before performing other actions

    fieldNameRef.current = fieldName;
    setShippingOptions((prevShippingOptions) => {
      const newShippingOptions = { ...prevShippingOptions, [fieldName]: value };
      return newShippingOptions;
    });

    if (fieldName === "shippingOption") {
      handleCartChange(undefined, undefined, value);
    }
  };
  const handleCartQuantityChange = async (
    productId: number,
    selectedOption: number
  ) => {
    let pid = productId.toString();
    handleCartChange(pid, selectedOption);
  };

  const addressRef = useRef<{
    formType: "billing" | "shipping" | null;
    data: intrfce.iAddressFormData | null;
  }>({
    formType: null,
    data: null,
  });
  const handleAddressUpdate = (data: any, formType: "billing" | "shipping") => {
    console.log("handleAddressUpdate===>", data, formType);
    let shipping: any = cartData?.shippingAddress;
    addressRef.current = { formType, data };

    if (formType === "shipping") {
      if (isShipping) {
        setFormShippingAddress(data);
        if (selectedAddressOption !== "recommendedAddress") {
          setTemporaryAddress({
            line1: data.address,
            line2: data.line2,
            city: data.cityValue,
            countrySubdivision: data.stateValue,
            postalCode: data.pincode,
            countryName: data.countryName,
            country: data.countryValue,
            firstName: formData.firstNameShiping || "",
            lastName: formData.lastNameShiping || "",
            phoneNumber: formData.contactShiping || "",
          });
        }
        setFormData((prevData) => ({
          ...prevData,
          iShippingFormAddress: data,
        }));
      } else {
        if (
          typeof selectedShippingAddress !== "string" &&
          Number(cartData?.shippingAddress?.id) !== selectedShippingAddress?.id
        ) {
          shipping = selectedShippingAddress ?? undefined;
        }

        if (
          shipping &&
          shipping.firstName &&
          shipping.lastName &&
          shipping.phoneNumber &&
          shipping.postalCode &&
          shipping.line1 &&
          shipping.city &&
          shipping.countrySubdivision &&
          shipping.country
        ) {
          setFormData((prevData) => ({
            ...prevData,
            ...(shipping.id ? { id: Number(shipping.id) } : {}),
            firstNameShiping: shipping.firstName,
            lastNameShiping: shipping.lastName,
            contactShiping: shipping.phoneNumber,
            iShippingFormAddress: {
              pincode: shipping.postalCode,
              address: shipping.line1,
              cityValue: shipping.city,
              stateValue:
                (stateDropdown || locale === 'zh-tw')
                  ? (locale === 'zh-tw' ? "TW" : shipping.countrySubdivision)
                  : undefined,
              county: countyField ? shipping.county || "-" : undefined,
              countryValue: shipping.country,
              countryName: shipping.countryName,
            },
          }));
        } else {
          setFormShippingAddress(data);
          setFormData((prevData) => ({
            ...prevData,
            iShippingFormAddress: data,
          }));
        }
      }
    } else {
      setFormBillingAddress(data);
      if (!isShipping) {
        setFormShippingAddress(data);
        isShippingAddressValid();
      }
      setFormData((prevData) => ({
        ...prevData,
        ...(shipping && shipping.firstName ? { firstNameShiping: shipping?.firstName } : {}),
        ...(shipping && shipping.lastName ? { lastNameShiping: shipping?.lastName } : {}),
        ...(shipping && shipping.phoneNumber ? { contactShiping: shipping?.phoneNumber } : {}),
        iBillingFormAddress: data,
        ...(!isShipping
          ? { iShippingFormAddress: data }
          : {
            iShippingFormAddress: {
              pincode: shipping?.postalCode ?? undefined,
              address: shipping?.line1 ?? undefined,
              cityValue: shipping?.city ?? undefined,
              stateValue:
                (locale === 'zh-tw' || stateDropdown)
                  ? (locale === 'zh-tw' ? "TW" : shipping?.countrySubdivision) : undefined,
              county:
                countyField ? shipping?.county ?? "-" : undefined,
              countryValue: shipping?.country ?? undefined,
              countryName: shipping?.countryName ?? undefined,
            },
          }),
      }));
    }
  };

  const handleRegisterSuccess = (result) => {
    sessionStorage.setItem("customer", "loggedIn");
    if (payment === "creditCard") {
      result.futureUse = futureUse;
    }
    let cartOrder = { cart: result };
    handleSubmitCart(cartOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleRegisterError = (e: any) => {
    sessionStorage.setItem("customer", "register");
    hideBodyLoader();
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      emailBilling:
        "The email address already exists for an account. Please enter a new email address.",
    }));
    console.error("Registration error:", e.message);
  };

  const handleRegister = async (a: any, b: any, c: any, d: any) => {
    if (!isObjectEmpty(b)) {
      showBodyLoader();
      await RegisterUser(
        isPartner,
        a,
        b,
        c,
        d,
        locale,
        handleRegisterSuccess,
        handleRegisterError
      );
    }
  };
  const handleCartSuccess = (res) => {
    if (isPartner && res?.paymentSession?.id) {
      sessionStorage.setItem("paymentSession", res?.paymentSession?.id);
    }
    setTemporaryAddress(null);
    if (userType) {
      showBodyLoader();
      // if (validPayment) {
      reviewOrder(userType);
      // } else {
      //   setShowAddressModal(false);
      //   setValidationErrors((prevErrors) => ({
      //     ...prevErrors,
      //     paymentSrc: "Please retry with a different payment method",
      //   }));
      // }
    }
  };

  const handleCartSourceError = () => {
    hideBodyLoader();
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      paymentSrc: "Please retry with a different payment method",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleCartError = (error: any) => {
    hideBodyLoader();

    // Handle error object
    if (error && error.code === "postal_code_invalid") {
      console.error("Postal code invalid:", error.message);
      // Add custom logic for invalid postal code error here (e.g., show specific UI message)
      setAddressErr(error?.description); // Example usage
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        addressErr: error?.description,
      }));
    } else if (error && error.message) {
      // Handle other errors
      emptyCart(error.message);
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  const handlePayPalSuccess = () => {
    showBodyLoader();
    reviewOrder(userType || "");
    hideBodyLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  const handlePayPalError = () => {
    hideBodyLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleSubmitCart = async (orderDet) => {
    let user: string | null = sessionStorage.getItem("customer");
    if (user && orderDet) {
      sessionStorage.setItem(user, JSON.stringify(orderDet));
      sessionStorage.setItem("isShipping", JSON.stringify(isShipping));
    }
    console.log("orderDet==>", orderDet);
    if (orderDet?.cart?.paymentOption?.sourceId) {
      showBodyLoader();
      if (isPartner) {
        await submitPartnerCart(
          { ...orderDet, locale: locale },
          handleCartSuccess,
          handleCartSourceError
        );
      } else {
        await submitCart(
          isPartner,
          { ...orderDet, locale: locale, brand: brand },
          handleCartSuccess,
          handleCartSourceError
        );
      }
    } else {
      showBodyLoader();
      await submitCart(
        isPartner,
        { ...orderDet, locale: locale, brand: brand },
        handleCartSuccess,
        handleCartError
      );
    }
  };

  const submitCustomerForm = () => {
    let userData = {};

    if (isBillingFormValid() && isBillingAddressValid()) {
      userData = {
        ...userData,
        ...formBillingData,
      };
      if (isShipping) {
        if (isShippingFormValid() && isShippingAddressValid()) {
          // If shipping fields are valid, proceed with registration
          userData = {
            ...userData,
            ...formBillingData,
            ...formShippingAddress,
          };
        } else {
          console.log(isShipping, formShippingAddress);
          return false; // Exit the function immediately if any field is invalid
        }
      }

      if (order && order?.cart && Object.keys(order?.cart).length === 0) {
        const billaddr = {
          ...(formBillingData.id ? { id: Number(formBillingData.id) } : {}),
          firstName: formBillingData.firstNameBilling || "",
          lastName: formBillingData.lastNameBilling || "",
          line1: formBillingAddress.address || "",
          line2: formBillingAddress.line2 || "",
          city: formBillingAddress.cityValue || "",
          countrySubdivision:
            (locale === 'zh-tw' || stateDropdown) ? (locale === 'zh-tw' ? "TW" : formBillingAddress.stateValue) : "",
          county: countyField ? formBillingAddress.county : undefined,
          postalCode: formBillingAddress.pincode || "",
          country: formBillingAddress.countryValue || "",
          countryName: formBillingAddress.countryName || "",
          emailAddress:
            formBillingData.emailBilling || cartData?.emailAddress || undefined,
          phoneNumber: formBillingData.contactBilling || "",
        };
        const shipaddr = {
          ...(isShipping
            ? formData.id
              ? { id: Number(formData.id) }
              : {}
            : formBillingData.id
              ? { id: Number(formBillingData.id) }
              : {}),
          firstName: isShipping
            ? formData.firstNameShiping
            : formBillingData.firstNameBilling || "",
          lastName: isShipping
            ? formData.lastNameShiping
            : formBillingData.lastNameBilling || "",
          line1: isShipping
            ? formShippingAddress.address
            : formBillingAddress.address || "",
          line2: isShipping
            ? formShippingAddress.line2
            : formBillingAddress.line2 || "",
          city: isShipping
            ? formShippingAddress.cityValue
            : formBillingAddress.cityValue || "",
          countrySubdivision:
            (locale === 'zh-tw' || stateDropdown)
              ? (locale === 'zh-tw' ? "TW" : isShipping
                ? formShippingAddress.stateValue
                : formBillingAddress.stateValue)
              : "",
          county:
            countyField
              ? isShipping
                ? formShippingAddress.county
                : formBillingAddress.county
              : undefined,
          postalCode: isShipping
            ? formShippingAddress.pincode
            : formBillingAddress.pincode || "",
          country: isShipping
            ? formShippingAddress.countryValue
            : formBillingAddress.countryValue || "",
          countryName: isShipping
            ? formShippingAddress.countryName
            : formBillingAddress.countryName || "",
          emailAddress: isShipping
            ? formBillingData.emailBilling
            : formBillingData.emailBilling || "",
          phoneNumber: isShipping
            ? formData.contactShiping
            : formBillingData.contactBilling || "",
        };
        const shipopt = shippingOptions?.shippingOption?.toString();
        const taxExempt = {
          companyName: formTaxData.companyName,
          taxAuthority: formTaxData.taxAuthority,
          startDate:
            "01/" + formTaxData.startDate + "/" + formTaxData.startYear,
          endDate:
            "28/" + formTaxData.expireDate + "/" + formTaxData.expireYear,
        };
        const updatedBillingAddress = billaddr; // Default to cartData's billingAddress
        const updatedShippingAddress = shipaddr; // Default to cartData's billingAddress
        // If cartData.billingAddress.emailAddress is null or empty, use cartData.emailAddress
        if (updatedBillingAddress && !updatedBillingAddress?.emailAddress) {
          updatedBillingAddress.emailAddress =
            cartData?.emailAddress || updatedBillingAddress.emailAddress;
        }
        if (updatedShippingAddress && !updatedShippingAddress?.emailAddress) {
          updatedShippingAddress.emailAddress =
            cartData?.emailAddress || updatedShippingAddress.emailAddress;
        }
        let cartPayload = {
          cart: {
            futureUse: futureUse,
            billingAddress: updatedBillingAddress,
            shippingAddress: updatedShippingAddress,
            shippingOptionId: shipopt,
            taxExemption: taxExempt,
            customAttributes: {
              attribute: [
                {
                  name: "shipToCategory",
                  value: shippingOptions.shippingTo,
                },
              ],
            },
          },
        };
        if (userType === "register") {
          handleRegister(
            formData,
            userData,
            formShippingAddress,
            shippingOptions
          );
        } else if (userType === "guest") {
          handleSubmitCart(cartPayload);
        } else {
          handleSubmitCart(cartPayload);
        }
      } else {
        if (userType === "register") {
          handleRegister(
            formData,
            userData,
            formShippingAddress,
            shippingOptions
          );
        } else if (userType === "guest") {
          handleSubmitCart(order);
        } else {
          handleSubmitCart(order);
        }
      }
    } else {
      console.log("Form has found missing field values");
      return false;
    }
  };
  const handleConfirmAddress = (e: React.MouseEvent<HTMLButtonElement>) => {
    let isLoggedIn = nvCookieHelpers.getCookie("isUserLoggedIn");
    if (isLoggedIn && JSON.parse(isLoggedIn)) {
      submitCustomerForm();
    } else {
      if (savePayment) {
        submitCustomerForm();
      } else {
        if (savePayment || validPayment) {
          if (!savePayment) {
            setValidationErrors((prevErrors) => ({
              ...prevErrors,
              paymentSrc: "Please retry with a different payment method",
            }));
            setShowAddressModal(false);
          }
          if (validPayment) {
            setValidationErrors((prevErrors) => ({
              ...prevErrors,
              paymentSrc: "",
            }));
            setSavePayment(true);
          }
        } else {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            paymentSrc: "Please retry with a different payment method",
          }));
          setShowAddressModal(false);
          e.preventDefault();
          return;
        }
      }
    }
  };
  const handleAddressSuccess = (result: any) => {
    console.log("handleAddressSuccess==>", result);
    setAddressValidationResult(result);
    updateRecommendedShippingAddress(result);
    setTemporaryAddress({
      id: 0,
      firstName: formData.firstNameShiping || "",
      lastName: formData.lastNameShiping || "",
      line1: formShippingAddress.address || "",
      line2: formShippingAddress.line2 || "",
      city: formShippingAddress.cityValue || "",
      countrySubdivision: formShippingAddress.stateValue || "",
      postalCode: formShippingAddress.pincode || "",
      country: formShippingAddress.countryValue || "",
      countryName: formShippingAddress.countryName || "",
      phoneNumber: formData.contactShiping || "",
      nickName: "Order Address",
      isDefault: false,
    });
    setShowAddressModal(true);
    hideBodyLoader();
  };
  const handleAddressError = (err) => {
    console.log("handleAddressError==>", err);
    hideBodyLoader();
    setShowAddressModal(true);
  };
  const validateAddress = async (addr: any) => {
    showBodyLoader();
    const invalidateRegions = ['CY', 'GR', 'RO'];
    if (addr?.regionCode && !invalidateRegions.includes(addr?.regionCode)) {
      await submitAddress(addr, handleAddressSuccess, handleAddressError);
    } else {
      setTemporaryAddress({
        id: 0,
        firstName: formData.firstNameShiping || "",
        lastName: formData.lastNameShiping || "",
        line1: formShippingAddress.address || "",
        line2: formShippingAddress.line2 || "",
        city: formShippingAddress.cityValue || "",
        countrySubdivision: formShippingAddress.stateValue || "",
        postalCode: formShippingAddress.pincode || "",
        country: formShippingAddress.countryValue || "",
        countryName: formShippingAddress.countryName || "",
        phoneNumber: formData.contactShiping || "",
        nickName: "Order Address",
        isDefault: false,
      });
      setShowAddressModal(true);
    }
  };
  const handleFormSubmit = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    const sessionexpiredID = nvCookieHelpers.getCookie("session_expired");
    if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
      if (cartData?.isDigital) {
        if (savePayment) {
          submitCustomerForm();
        } else {
          //setShowAddressModal(true);
          ev.preventDefault();
          setSavePayment(true);
          return;
        }
      } else {
        const addressObj = {
          regionCode: isShipping
            ? formShippingAddress.countryValue
            : formBillingAddress.countryValue,
          addressLines: [
            `${isShipping ? formShippingAddress.address : formBillingAddress.address}${(isShipping ? formShippingAddress.line2 : formBillingAddress.line2) ? `, ${isShipping ? formShippingAddress.line2 : formBillingAddress.line2}` : ''}, ${isShipping ? formShippingAddress.cityValue : formBillingAddress.cityValue}, ${locale === "en-us" ? (isShipping ? formShippingAddress.stateValue : formBillingAddress.stateValue) : ''} ${isShipping ? formShippingAddress.pincode : formBillingAddress.pincode}`,
          ]
        };
        if (isShipping) {
          if (isShippingFormValid() && isShippingAddressValid()) {
            validateAddress(addressObj);
          } else {
            return false;
          }
        } else {
          if (isBillingFormValid() && isBillingAddressValid()) {
            validateAddress(addressObj);
          } else {
            return false;
          }
        }
        // submitCustomerForm();
      }
      ev.preventDefault();
      if (
        Object.values(validationErrors).some(
          (error): error is string =>
            typeof error === "string" && error.length > 0
        )
      ) {
        return false;
      } else {
      }
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
  };

  const updateSuggestedShippingAddress = (suggestedAddr: any) => {
    console.log("updateSuggestedShippingAddress==>", suggestedAddr);

    Object.keys(suggestedAddr).forEach((fieldName) => {
      if (suggestedAddr[fieldName] && suggestedAddr[fieldName].length) {
        validateForm(fieldName, suggestedAddr[fieldName], "shipping");
      }
    });
    // Update savedShippingAddress - replace object with id 0 if it exists, otherwise add it
    setSavedShippingAddress((prev) => {
      if (prev) {
        const index = prev.findIndex((addr) => addr.id === 0);
        if (index !== -1) {
          // Replace existing object with id 0
          const newArray = [...prev];
          newArray[index] = suggestedAddr;
          return newArray;
        }
        // If no object with id 0 exists, add the new one
        return [...prev, suggestedAddr];
      } else {
        return [suggestedAddr];
      }
    });

    // Then update form data with the same address format
    setFormShippingAddress({
      pincode: suggestedAddr.postalCode,
      address: suggestedAddr.line1,
      line2: suggestedAddr.line2,
      cityValue: suggestedAddr.city,
      stateValue: suggestedAddr.countrySubdivision,
      countryName: suggestedAddr.countryName,
      countryValue: suggestedAddr.country,
    });

    // Update formData with id: 0 and the recommended address
    setFormData((prevData) => ({
      ...prevData,
      id: 0, // Set id to 0 in formData
      firstNameShiping: suggestedAddr.firstName,
      lastNameShiping: suggestedAddr.lastName,
      contactShiping: suggestedAddr.phoneNumber,
      iShippingFormAddress: {
        pincode: suggestedAddr.postalCode,
        address: suggestedAddr.line1,
        line2: suggestedAddr.line2,
        cityValue: suggestedAddr.city,
        stateValue: suggestedAddr.countrySubdivision,
        countryName: suggestedAddr.countryName,
        countryValue: suggestedAddr.country,
      },
    }));

    // Update selectedShippingAddress with id: 0
    setSelectedShippingAddress(suggestedAddr);
  };
  const handleShippingAddressUpdate = (
    ev: React.MouseEvent<HTMLButtonElement>
  ) => {
    handleisShippingChange(ev, selectedAddressOption === "yourAddress");

    const updatedShippingAddress = {
      id: 0, // Set id to 0 for recommended address
      city: formShippingAddress.cityValue || "",
      country: formShippingAddress.countryValue || "US",
      countryName: formShippingAddress.countryName || "United States",
      countrySubdivision: formShippingAddress.stateValue || "",
      firstName: formData.firstNameShiping || "",
      lastName: formData.lastNameShiping || "",
      line1: formShippingAddress.address || "",
      line2: formShippingAddress.line2 || "",
      nickName: "Order Address",
      phoneNumber: formData.contactShiping || "",
      postalCode: formShippingAddress.pincode || "",
      isDefault: false,
    };
    // First update savedShippingAddress
    updateSuggestedShippingAddress(updatedShippingAddress);
    setShowAddressModal(false);
  };

  const updateRecommendedShippingAddress = (result: any) => {
    if (result?.result?.address?.postalAddress) {
      const postalAddress = result.result.address.postalAddress;
      const addressData = {
        ...(postalAddress.postalCode && { pincode: postalAddress.postalCode || '' }),
        ...(postalAddress.addressLines && postalAddress.addressLines?.length > 0 && {
          address: (/^\D+$/.test(postalAddress.addressLines.join('')) && locale !== "en-gb")
            ? postalAddress.addressLines.join(", ") + ', ' + postalAddress.postalCode || ''
            : postalAddress.addressLines.join(", ") || ''
        }),
        ...(postalAddress.locality && { cityValue: postalAddress.locality || '' }),
        ...(postalAddress.administrativeArea && { stateValue: postalAddress.administrativeArea || '' }),
        ...(postalAddress.countryName && { countryName: postalAddress.countryName || '' }),
        ...(postalAddress.regionCode && { countryValue: postalAddress.regionCode || "US" }),
      };

      // Check if addressData matches formShippingAddress
      const differences: string[] = [];
      if (addressData.pincode !== formShippingAddress.pincode)
        differences.push("pincode");
      if (addressData.address !== formShippingAddress.address)
        differences.push("address");
      if (addressData.line2 !== formShippingAddress.line2)
        differences.push("line2");
      if (addressData.cityValue !== formShippingAddress.cityValue)
        differences.push("city");
      if (addressData.stateValue !== formShippingAddress.stateValue)
        differences.push("state");
      if (addressData.countryName !== formShippingAddress.countryName)
        differences.push("country name");
      if (addressData.countryValue !== formShippingAddress.countryValue)
        differences.push("country code");

      if (differences.length > 0) {
        console.log("Different fields:", differences);
      }

      Object.keys(addressData).forEach((fieldName) => {
        if (addressData[fieldName] && addressData[fieldName].length) {
          validateForm(fieldName, addressData[fieldName], "shipping");
        }
      });
      const isEqual = differences.length === 0;
      setRecommendedShippingAddress(isEqual ? null : addressData);
    }
  };

  const handleAddressOptionChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    option: string
  ) => {
    setSelectedAddressOption(option);
    if (option === "recommendedAddress" && recommendedShippingAddress) {
      handleisShippingChange(e, option === "recommendedAddress");

      const newShippingAddress = {
        id: 0, // Set id to 0 for recommended address
        city: recommendedShippingAddress.cityValue || "",
        country: recommendedShippingAddress.countryValue || "US",
        countryName: countries[0].countryName || '',
        countrySubdivision: recommendedShippingAddress.stateValue || "",
        firstName: formData.firstNameShiping || "",
        lastName: formData.lastNameShiping || "",
        line1: recommendedShippingAddress.address || "",
        line2: recommendedShippingAddress.line2 || "",
        nickName: "Order Address",
        phoneNumber: formData.contactShiping || "",
        postalCode: recommendedShippingAddress.pincode || "",
        isDefault: false,
      };
      updateSuggestedShippingAddress(newShippingAddress);
    } else {
      if (option === "yourAddress" && temporaryAddress) {
        updateSuggestedShippingAddress(temporaryAddress);
      }
    }
  };

  return (
    <div className="User">
      <Container>
        <Form className="orderAddressDetails" autoComplete="none" aria-labelledby="orderAddressDetails">
          <Row xs={"auto"} md={"auto"}>
            <Col md={"7"} sm={"auto"} className="w100" role="region" aria-labelledby="cartSectionHeader">
              <Card id="ShoppingCartMobile">
                <div className={isCartLoading ? `cart-loading` : ""} aria-busy={isCartLoading}>
                  {isCartLoading && (
                    <Image
                      src={cartLoader}
                      className="cartLoader"
                      alt="Loading cart"
                    ></Image>
                  )}
                  {cartData && (
                    <Cart
                      onCartChange={handleCartQuantityChange}
                      validationErrors={validationErrors}
                      onPromoChange={handleCouponChange}
                      onPromoSubmit={handleCouponSubmit}
                      onPromoDelete={handleCouponDelete}
                      isThanks={isThanks}
                      isDownload={isDownload}
                      isVerify={isVerify}
                      cartData={cartData}
                      promoCodeError={promoErr}
                    />
                  )}
                </div>
              </Card>
              <div id="newLoginContainer">
                {userType === "loggedIn" && <h1 id="orderAddressDetails">{t("VERIFY_ORDER_HEADER")}</h1>}
                {userType === "guest" && <h1 id="orderAddressDetails">{t("CHECKOUT_GUEST_BTN")}</h1>}
                {userType === "register" && (
                  <h1 id="orderAddressDetails">{t("NEW_ACCOUNT_INFORMATION")}</h1>
                )}
                {userType === "guest" && (
                  <p className="dr_loginInstructions">
                    {t("HAVE_AN_ACCOUNT")}{" "}
                    <Button className="continue" onClick={handleLogin}>
                      {t("SITE_LOGIN_PAGE_TITLE")}
                    </Button>
                  </p>
                )}
              </div>
              <h3 id="cartSectionHeader" className="visually-hidden">{t("SHOPPING_CART_HEADER")}</h3>
              {addressErr && (
                <>
                  <p
                    className={`addressErr ${validationErrors.addressErr ? "is-invalid" : ""
                      }`}
                  ></p>
                  <Form.Control.Feedback type="invalid" id="addressErr" aria-live="polite" aria-describedby="addressErr">
                    {validationErrors.addressErr}
                  </Form.Control.Feedback>
                </>
              )}
              <Row xs={"auto"} md={"auto"} className="mb-2" role="region" aria-labelledby="billingDetailsHeader">
                <h3
                  id="billingDetailsHeader"
                  className={`billingDetails ${validationErrors.register ? "is-invalid" : ""}`} >
                  {t("BILLING_ADDRESS")}
                </h3>
                <Form.Control.Feedback type="invalid" id="billingDetailsError" aria-live="polite">
                  {validationErrors.register}
                </Form.Control.Feedback>
              </Row>
              <Row xs={"auto"} md={"auto"} className=" mb-2" role="region" aria-labelledby="billingDetailsForm" id="billingDetailsForm">
                <Col md={6}>
                  {userType === "loggedIn" &&
                    savedBillingAddress &&
                    savedBillingAddress.length > 0 ? (
                    <Form.Group controlId="savedBillingAddress" id="billingAddressSelect" aria-label="Saved Billing Address" role="region" aria-labelledby="billingAddressSelect">
                      {/* Add a visible label for the select, or use aria-label if not possible */}
                      <label htmlFor="savedBillingAddressSelect" className="visually-hidden">
                        Select Billing Address
                      </label>
                      <Form.Select
                        id="savedBillingAddressSelect"
                        autoComplete="none"
                        value={selectedBillingAddress ? selectedBillingAddress["id"] : ""}
                        name="savedBillingAddress"
                        aria-label="Select Billing Address" // use only if no visible label
                        aria-required="true" // if this is a required field
                        onChange={(e) =>
                          handleSavedBillingAddressChange(
                            "savedBillingAddress",
                            e.target.value
                          )
                        }
                      >
                        {savedBillingAddress?.map((address, index) => (
                          <option
                            key={address["id"] ?? index}
                            value={address["id"]}
                            selected={address["isDefault"]}
                            aria-selected={address["isDefault"]}
                            aria-label={address["nickName"]}
                            aria-describedby="billingAddressSelect"
                          // Remove selected, React handles it via value on <select>
                          >
                            {address["nickName"]}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  ) : null}
                </Col>
                {userType === "loggedIn" &&
                  savedBillingAddress &&
                  savedBillingAddress.length ? (
                  <Col md={6}>
                    <Button
                      variant="link"
                      className="btn-add pull-right"
                      onClick={() =>
                        handleSavedBillingAddressChange(
                          "savedBillingAddress",
                          RESET_ADDRESS
                        )
                      }
                      aria-label="Add new address"
                      aria-describedby="addNewAddress"
                      aria-live="polite"
                    >
                      <FaPlus /> &nbsp;{t("ADD_NEW_ADDRESS")}
                    </Button>
                    <span id="addNewAddress" className="visually-hidden">
                      {t("ADD_NEW_ADDRESS_DESCRIPTION") || "Add a new billing address to your account"}
                    </span>
                  </Col>
                ) : null}
              </Row>
              <Row xs={"auto"} md={"auto"} className="mb-4">
                {locale !== 'ja-jp' ? (
                  <>
                    <Billing
                      userType={userType}
                      onInputChange={handleBillingInputChange}
                      formBillingDetails={formBillingData}
                      validationErrors={validationErrors}
                      isReadOnly={isBillingReadonly}
                      billingUser={
                        selectedBillingAddress
                          ? JSON.stringify(selectedBillingAddress)
                          : ""
                      }
                    />
                    <Places
                      isThanks={isThanks}
                      isDownload={isDigitalProduct}
                      isVerify={isVerify}
                      validationErrors={validationErrors}
                      isBillingReadonly={isBillingReadonly}
                      billingAddr={
                        selectedBillingAddress
                          ? JSON.stringify(selectedBillingAddress)
                          : ""
                      }
                      formType="billing"
                      isShippingReadonly={isShippingReadonly}
                      onPlaceUpdate={(data) => handleAddressUpdate(data, "billing")}
                      brand={brand}
                    />
                  </>
                ) : (
                  <>
                    <BillingJapan
                      userType={userType}
                      onInputChange={handleBillingInputChange}
                      formBillingDetails={formBillingData}
                      validationErrors={validationErrors}
                      isReadOnly={isBillingReadonly}
                      billingUser={
                        selectedBillingAddress
                          ? JSON.stringify(selectedBillingAddress)
                          : ""
                      }
                    />
                    <PlacesJapan
                      isThanks={isThanks}
                      isDownload={isDigitalProduct}
                      isVerify={isVerify}
                      validationErrors={validationErrors}
                      isBillingReadonly={isBillingReadonly}
                      billingAddr={
                        selectedBillingAddress
                          ? JSON.stringify(selectedBillingAddress)
                          : ""
                      }
                      formType="billing"
                      isShippingReadonly={isShippingReadonly}
                      onPlaceUpdate={(data) => handleAddressUpdate(data, "billing")}
                    />
                  </>
                )}
              </Row>
              {!cartData?.isDigital && (
                <Row xs={"auto"} md={"auto"} className="mb-4">
                  <Col md={12}>
                    <Form.Group className="isShipping" controlId="isShipping">
                      <Form.Check
                        type="checkbox"
                        name="sameShipping"
                        label={t("SHIPPING_ADDRESS_DIFFERENT_BILLING")}
                        checked={isShipping}
                        onChange={handleisShippingChange}
                        aria-checked={isShipping}
                        aria-label={t("SHIPPING_ADDRESS_DIFFERENT_BILLING")}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {isShipping && !cartData?.isDigital && (
                <>
                  <Row xs={"auto"} md={"auto"} className={shipingInfo} id="shippingDetailsHeader" role="region" aria-labelledby="shippingDetailsHeader" aria-describedby="shippingDetails">
                    <Col md={12} className="p-0">
                      <h3 id="shippingDetailsHeader" role="region" aria-labelledby="shippingDetailsHeader" aria-describedby="shippingDetails" className="shippingDetails">{t("SHIPPING_INFORMATION")}</h3>
                      <p className="instructions" id="shippingDetails" role="region" aria-labelledby="shippingDetails" aria-describedby="shippingDetails">{t("SHIPPING_INSTRUCTIONS")}</p>
                      <p className="instructions" id="shippingDetails" role="region" aria-labelledby="shippingDetails" aria-describedby="shippingDetails">{t("REQUIRED_FIELDS_TEXT")}</p>
                    </Col>
                  </Row>
                  <Row xs={"auto"} md={"auto"} id="shippingDetailsForm" role="region" aria-labelledby="shippingDetailsForm" aria-describedby="shippingDetailsForm">
                    <Col md={6}>
                      {userType === "loggedIn" &&
                        savedShippingAddress &&
                        savedShippingAddress.length > 0 && (
                          <Form.Group controlId="savedShippingAddress" id="shippingAddressSelect" role="region" aria-labelledby="shippingAddressSelect" aria-describedby="shippingAddressSelect">
                            <Form.Select
                              autoComplete="none"
                              value={
                                selectedShippingAddress
                                  ? selectedShippingAddress["id"]
                                  : ""
                              }
                              name="savedShippingAddress"
                              aria-label="Select Shipping Address"
                              onChange={(e) =>
                                handleSavedShippingAddressChange(
                                  "savedShippingAddress",
                                  e.target.value
                                )
                              }
                              aria-invalid={!!validationErrors.savedShippingAddress}
                              aria-describedby={validationErrors.savedShippingAddress ? "savedShippingAddressError" : undefined}
                              isInvalid={!!validationErrors.savedShippingAddress}
                            >
                              {savedShippingAddress?.map((address, index) => (
                                <option
                                  key={index}
                                  value={address["id"]}
                                  selected={address["isDefault"]}
                                >
                                  {address["nickName"]}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid" id="savedShippingAddressError" aria-live="polite" aria-describedby="savedShippingAddressError">
                              {validationErrors.savedShippingAddress}
                            </Form.Control.Feedback>
                          </Form.Group>
                        )}
                    </Col>
                    {userType === "loggedIn" &&
                      savedShippingAddress &&
                      savedShippingAddress.length > 0 && (
                        <Col md={6}>
                          <Button
                            variant="link"
                            className="btn-add pull-right"
                            onClick={() =>
                              handleSavedShippingAddressChange(
                                "savedShippingAddress",
                                RESET_ADDRESS
                              )
                            }
                            aria-label="Add new shipping address"
                            aria-describedby="shippingAddressSelect"
                          >
                            <FaPlus /> &nbsp;{t("ADD_NEW_ADDRESS")}
                          </Button>
                        </Col>
                      )}
                  </Row>
                  <Row xs={"auto"} md={"auto"} className="mb-4">
                    <div className="Shipping" id="shippingDetailsForm" role="region" aria-labelledby="shippingDetailsForm" aria-describedby="shippingDetailsForm">
                      {locale === 'ja-jp' && (
                        <Col md={6}>
                          <Form.Group controlId="lastNameShiping">
                            <Form.Label htmlFor="lastNameShiping" className="visually-hidden">{t("LAST_NAME")}</Form.Label>
                            <Form.Control
                              id="lastNameShiping"
                              className={`form-control ${isShippingReadonly ? "disabled" : ""
                                }`}
                              required={isShipping}
                              readOnly={isShippingReadonly}
                              placeholder={t("LAST_NAME_REQUIRED")}
                              type="text"
                              autoComplete="none"
                              aria-required="true"
                              aria-invalid={!!validationErrors.lastNameShiping}
                              aria-describedby={validationErrors.lastNameShiping ? "lastNameShipingError" : undefined}
                              isInvalid={!!validationErrors.lastNameShiping}
                              name="lastNameShiping"
                              value={formData.lastNameShiping}
                              onBlur={(e) =>
                                handleInputChange(
                                  "lastNameShiping",
                                  e.target.value
                                )
                              }
                              onChange={(e) =>
                                handleInputChange(
                                  "lastNameShiping",
                                  e.target.value
                                )
                              }
                            />
                            <Form.Control.Feedback type="invalid" id="lastNameShipingError" aria-live="polite" aria-describedby="lastNameShipingError">
                              {validationErrors.lastNameShiping}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      )}
                      <Col md={6}>
                        <Form.Group controlId="firstNameShiping">
                          <Form.Label htmlFor="firstNameShiping" className="visually-hidden">{t("FIRST_NAME")}</Form.Label>
                          <Form.Control
                            id="firstNameShiping"
                            className={`form-control ${isShippingReadonly ? "disabled" : ""
                              }`}
                            required={isShipping}
                            readOnly={isShippingReadonly}
                            placeholder={t("FIRST_NAME_REQUIRED")}
                            type="text"
                            autoComplete="none"
                            aria-required="true"
                            aria-invalid={!!validationErrors.firstNameShiping}
                            aria-describedby={validationErrors.firstNameShiping ? "firstNameShipingError" : undefined}
                            isInvalid={!!validationErrors.firstNameShiping}
                            name="firstNameShiping"
                            value={formData.firstNameShiping}
                            onBlur={(e) =>
                              handleInputChange(
                                "firstNameShiping",
                                e.target.value
                              )
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "firstNameShiping",
                                e.target.value
                              )
                            }
                          />
                          <Form.Control.Feedback type="invalid" id="firstNameShipingError" aria-live="polite" aria-describedby="firstNameShipingError">
                            {validationErrors.firstNameShiping}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {locale !== 'ja-jp' && (<Col md={6}>
                        <Form.Group controlId="lastNameShiping">
                          <Form.Label htmlFor="lastNameShiping" className="visually-hidden">{t("LAST_NAME")}</Form.Label>
                          <Form.Control
                            id="lastNameShiping"
                            className={`form-control ${isShippingReadonly ? "disabled" : ""
                              }`}
                            required={isShipping}
                            readOnly={isShippingReadonly}
                            placeholder={t("LAST_NAME_REQUIRED")}
                            type="text"
                            autoComplete="none"
                            aria-required="true"
                            aria-invalid={!!validationErrors.lastNameShiping}
                            aria-describedby={validationErrors.lastNameShiping ? "lastNameShipingError" : undefined}
                            isInvalid={!!validationErrors.lastNameShiping}
                            name="lastNameShiping"
                            value={formData.lastNameShiping}
                            onBlur={(e) =>
                              handleInputChange(
                                "lastNameShiping",
                                e.target.value
                              )
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "lastNameShiping",
                                e.target.value
                              )
                            }
                          />
                          <Form.Control.Feedback type="invalid" id="lastNameShipingError" aria-live="polite" aria-describedby="lastNameShipingError">
                            {validationErrors.lastNameShiping}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>)}
                      <Col md={6}>
                        <Form.Group controlId="contactShiping">
                          <Form.Label htmlFor="contactShiping" className="visually-hidden">{t("PHONE_NUMBER")}</Form.Label>
                          <Form.Control
                            id="contactShiping"
                            className={`form-control ${isShippingReadonly ? "disabled" : ""
                              }`}
                            required={isShipping}
                            readOnly={isShippingReadonly}
                            placeholder={t("PHONE_NUMBER_REQUIRED")}
                            type="text"
                            autoComplete="none"
                            aria-required="true"
                            aria-invalid={!!validationErrors.contactShiping}
                            aria-describedby={validationErrors.contactShiping ? "contactShipingError" : undefined}
                            isInvalid={!!validationErrors.contactShiping}
                            name="contactShiping"
                            value={formatPhoneNo(formData.contactShiping)}
                            onBlur={(e) =>
                              handleInputChange(
                                "contactShiping",
                                e.target.value
                              )
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "contactShiping",
                                e.target.value
                              )
                            }
                          />
                          <Form.Control.Feedback type="invalid" id="contactShipingError" aria-live="polite" aria-describedby="contactShipingError">
                            {validationErrors.contactShiping}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </div>
                    {locale !== 'ja-jp' ? (<Places
                      isThanks={isThanks}
                      isDownload={isDigitalProduct}
                      isVerify={isVerify}
                      validationErrors={validationErrors}
                      isShippingReadonly={isShippingReadonly}
                      billingAddr={
                        selectedShippingAddress
                          ? JSON.stringify(selectedShippingAddress)
                          : ""
                      }
                      formType="shipping"
                      isBillingReadonly={isBillingReadonly}
                      onPlaceUpdate={(data) =>
                        handleAddressUpdate(data, "shipping")
                      }
                      brand={brand}
                    />
                    ) : (
                      <PlacesJapan
                        isThanks={isThanks}
                        isDownload={isDigitalProduct}
                        isVerify={isVerify}
                        validationErrors={validationErrors}
                        isShippingReadonly={isShippingReadonly}
                        billingAddr={
                          selectedShippingAddress
                            ? JSON.stringify(selectedShippingAddress)
                            : ""
                        }
                        formType="shipping"
                        isBillingReadonly={isBillingReadonly}
                        onPlaceUpdate={(data) =>
                          handleAddressUpdate(data, "shipping")
                        }
                      />
                    )}
                  </Row>
                </>
              )}
              {cartData && !isPhysicalGiftCard && !cartData.isDigital && (
                <Shipping
                  partner={isPartner}
                  isDirect={isDirect}
                  shippingList={{ shippingOption: shippingList }}
                  shippingPlace={{ shippingToList: shippingPlace }}
                  defaultShippingMethodCode={shippingOptions}
                  validationErrors={validationErrors}
                  onInputChange={handleShippingMethodChange}
                />
              )}
              <Row xs={"auto"} md={"auto"}>
                <Col md={12}>
                  {cartData && !cartData?.zdt && (
                    <Payment
                      billingData={selectedBillingAddress}
                      savePayment={savePayment}
                      validationErrors={validationErrors}
                      formBillingAddress={formBillingAddress}
                      formBillingData={formBillingData}
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={"5"} sm={"auto"} className="w100">
              <Card id="ShoppingCart">
                <div className={isCartLoading ? `cart-loading` : ""}>
                  {isCartLoading && (
                    <Image
                      src={cartLoader}
                      className="cartLoader"
                      alt="CartLoader"
                    ></Image>
                  )}
                  {cartData && (
                    <Cart
                      onCartChange={handleCartQuantityChange}
                      validationErrors={validationErrors}
                      onPromoChange={handleCouponChange}
                      onPromoSubmit={handleCouponSubmit}
                      onPromoDelete={handleCouponDelete}
                      isThanks={isThanks}
                      isDownload={isDownload}
                      isVerify={isVerify}
                      cartData={cartData}
                      promoCodeError={promoErr}
                    />
                  )}
                </div>
              </Card>
            </Col>
            <Col md={7} sm={12} className="w100 orderReviewCTA">
              <Button
                type="button"
                variant="success"
                className="btn-green orderReviewBtn"
                onClick={handleFormSubmit}
                disabled={!enableReviewOrderBtn}
                aria-label={t("BTN_REVIEW_ORDER")}
              >
                {t("BTN_REVIEW_ORDER")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
      <AddressModal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
        selectedAddressOption={selectedAddressOption}
        temporaryAddress={temporaryAddress}
        recommendedShippingAddress={recommendedShippingAddress}
        addressValidationResult={addressValidationResult}
        formShippingAddress={formShippingAddress}
        onAddressOptionChange={handleAddressOptionChange}
        onShippingAddressUpdate={handleShippingAddressUpdate}
        onConfirmAddress={handleConfirmAddress}
      />
    </div>
  );
};
export default User;
